export default {
  v5: {
    select_files_to_upload: 'Select files to upload',
    my_video_shorts: 'MOJI VIDEO SHORTS',
    see_more: 'Pogledaj više',
    no_shorts_found: 'Nema pronađenih Shorts',
    shorts: 'Shorts',
    general_information: 'Opšte informacije',
    gamification: 'Gamifikacija',
    click_to_select_files: 'Kliknite da izaberete fajlove',
    selected_files: 'Izabrani fajlovi',
    uploaded: 'Otpremљeno',
    failed: 'Neuspelo',
    system_will_automatically_analyze_and_select_the_most_relevant:
      'Sistem će automatski analizirati i odabrati najrelevantnije dokumente iz biblioteke vaše organizacije na osnovu zahteva za sadržajem.',
    select_from_library: ' Izaberite iz biblioteke',
    search_document: 'Pretraži dokumente...',
    selected: 'Izabrano',
    loading_documents: 'Učitavanje dokumenata...',
    review_generated_content: 'Proveri generisani sadržaj',
    confirm_and_replace_content: 'Potvrdi i zameni sadržaj',
    the_generate_content_will_replace:
      'Generisani sadržaj će zameniti postojeći tekst na izabranim stranicama. Ako ne želite da primenite ove promene, možete se vratiti na prethodni korak.',
    pages_to_be_updated: 'Stranice koje će biti ažurirane',
    generated_revisions: 'Generisane revizije',
    lesson_preview: 'Pregled lekcije',
    create_new_folder: 'Kreiraj novu fasciklu',
    rename_item: 'Preimenuj stavku',
    enter_folder_name: 'Unesite ime fascikle:',
    enter_new_name: 'Unesite novo ime:',
    folder_name: 'Ime fascikle:',
    new_name: 'Novo ime',
    move_items: 'Premesti stavke',
    copy_items: 'Kopiraj stavke',
    move_here: 'Premesti ovde',
    copy_here: 'Kopiraj ovde',
    select_destination_library_and_folder:
      'Izaberite destinacijsku biblioteku i fasciklu:',
    items_selected: 'Izabrane stavke',
    version: 'Verzija',
    modified_by: 'Izmenio',
    size: 'Veličina',
    restore: 'Vrati',
    are_you_sure_you_want_to_restore_this_version:
      'Da li ste sigurni da želite da vratite ovu verziju?',
    this_will_replce_the_current_version_with_the_selected_one:
      'Ovo će zameniti trenutnu verziju sa izabranom.',
    restore_this_version: 'Vrati ovu verziju',
    restore_not_available: 'Vraćanje nije dostupno',
    version_history: 'Istorija verzija:',
    by_making_items_public:
      'Kada stavke učinite javnim, one će biti vidljive svima. Molimo pročitajte uslove pre nego što nastavite.',
    the_selected_items_will_be_copied:
      'Izabrane stavke biće kopirane u vašu javnu biblioteku i biće vidljive svima.',
    the_selected_items_will_be_copied_to_org:
      'Izabrane stavke biće kopirane u biblioteku vaše organizacije i biće vidljive svim članovima organizacije.',
    the_selected_items_will_be_copied_to_your_private:
      'Izabrane stavke biće kopirane u vašu privatnu biblioteku i biće vidljive samo vama.',
    loading_organization: 'Učitavanje korisnika organizacije...',
    click_download_to_view: 'Kliknite „Preuzmi“ da pregledate',
    archive_file: 'Arhivski fajl',
    no_preview_available: 'Pregled nije dostupan',
    audit_report: 'Izveštaj revizije',
    audit_type: 'Tip akcije',
    i_agree_to_the_terms_and_conditions: 'Slažem se sa uslovima korišćenja.',
    this_file_is_indexed_for_ai: 'Ovaj fajl je indeksiran za AI.',
    file_is_not_indexed_for_ai: 'Fajl nije indeksiran za AI.',
    no_users_found: 'Korisnici nisu pronađeni',
    no_users_available: 'Nema dostupnih korisnika',
    add_people: 'Dodaj ljude',
    people: 'Ljudi',
    access_type: 'Tip pristupa',
    no_group_found: 'Grupe nisu pronađene',
    add_group: 'Dodaj grupe',
    groups: 'Grupe',
    users_top: 'korisnik(a)',
    confirm_delete: 'Potvrdi brisanje',
    do_you_want_remove: 'Da li ste sigurni da želite ukloniti',
    form_this_documents_permissions: 'iz dozvola ovog dokumenta?',
    no_users_found_in_this_group: 'Korisnici nisu pronađeni u ovoj grupi',
    add_selected_users: 'Dodaj izabrane korisnike',
    choose_users_from_the_list: 'Izaberite korisnike sa liste',
    selected_users: 'Izabrani korisnici',
    archived: 'Arhivirano',
    request_approval: 'Zahtev za odobrenje',
    document_in_review: 'Dokument je na pregledu',
    approve: 'Odobri',
    reject: 'Odbaci',
    comment: 'Komentar:',
    enter_your_commit: 'Unesite vaš komentar...',
    confirm_cancel: 'Potvrdi otkazivanje',
    upload_3d_zip: 'Otpremi 3D ZIP',
    delete_items: 'Obriši stavke',
    video_upload_request: 'Zahtev za upload videa',
    reject_video: 'Odbaci video',
    enter_rejection_reason: 'Unesite razlog odbijanja...',
    please_provide_a_reason_for_reejection_this_video:
      'Molimo navedite razlog odbijanja ovog videa:',
    generate_trivia_with_ai: 'Generiši kviz sa AI',
    select_category: 'Izaberite kategoriju:',
    number_of_question: 'Broj pitanja',
    generated_questions: 'Generisana pitanja',
    this_will_clear_all_generate_question:
      'Ovo će obrisati sva generisana pitanja. Nastaviti?',
    sure_delete: 'Da li ste sigurni da želite da obrišete?',
    delete_this_question:
      'Da li ste sigurni da želite da obrišete ovo pitanje?',
    loading_quiz: 'Učitavanje kviza...',
    creteing_file: 'Kreiranje fajla',
    opening_desktop_app: 'Otvaranje desktop aplikacije',
    this_folder_is_empty: 'Ova fascikla je prazna',
    select_a_competition: 'Izaberite takmičenje...',
    activity_badges: 'Bedževi aktivnosti',
    awarded_every_badges:
      'Dodeljuje se na svakih 4, 8, 16, 32, 64, 128, 256, 512 prijava',
    learning_badges: 'Bedževi učenja',
    awarded_every_courses:
      'Dodeljuje se na svakih 1, 4, 8, 16, 32, 64, 128 završenih kurseva',
    test_badges: 'Test bedževi',
    awarded_every_passes_tests:
      'Dodeljuje se na svakih 2, 4, 8, 16, 32, 64, 128, 256 položenih testova',
    assignment_badges: 'Bedževi zadataka',
    awarded_every_passed_assignments:
      'Dodeljuje se na svakih 1, 2, 4, 8, 16, 32, 64, 128 položenih zadataka',
    perfectionism_badges: 'Bedževi perfekcionizma',
    awarded_every_assignments_with_scrore:
      'Dodeljuje se na svakih 1, 2, 4, 8, 16, 32, 64, 128 testova ili zadataka sa rezultatom 90%+',
    communication_badges: 'Bedževi komunikacije',
    awarded_every_topics_or_comments:
      'Dodeljuje se na svakih 2, 4, 8, 16, 32, 64, 128, 256 tema ili komentara',
    certification_badges: 'Bedževi sertifikacije',
    awarded_every_certificates:
      'Dodeljuje se na svakih 1, 2, 4, 8, 16, 32, 64, 128 sertifikata',
    level_name: 'Naziv nivoa',
    delete_competition: 'Obriši takmičenje',
    this_week: 'Ove nedelje',
    this_year: 'Ove godine',
    make_organization: 'Napravite organizaciju',
    no_results_found: 'Nema rezultata za',
    no_items_available: 'Nema dostupnih stavki',
    help_video: 'Video pomoć',
    select_a_video_from_the_list:
      'Izaberite video sa liste da biste počeli sa učenjem'
  },
  v4: {
    upload_another_file: 'Upload another file',
    all_files_uploaded: 'All files uploaded',
    upload_and_submit: 'Upload & Submit',
    drop_files: 'Prevucite datoteke i izaberite gde će biti otpremljene.',
    duplicate_lessoon: 'Lekcija je već prisutna na kursu',
    skill_rule_title: 'Unesite naslov putovanja veština',
    imageCreatorTitle: 'Kreirač slika',
    isTranslated: 'Prevedeno',
    translationCourseDesc:
      'Prevod ovog kursa može potrajati nekoliko minuta. Hvala na strpljenju!',
    translateCourseTip:
      'Napravite prevedeni kurs koji možete promeniti nezavisno od originala, uključujući sve lekcije i stranice.',
    translateModalBtn: 'Prevedi',
    translationSuccess: 'Kurs „<0/>“ je uspešno preveden!',
    translatingCourse: 'Prevođenje kursa...',
    translateModalTitle: 'Prevedi kurs',
    translateSelectLang: 'Izaberite jezik',
    fileDeleteconfirm:
      'Da li ste sigurni da želite da obrišete ovu datoteku? Ovu radnju nije moguće opozvati.',
    fileDeleteMessage: 'Datoteka je uspešno obrisana.',
    fileDeleteFailedMessage: 'Brisanje datoteke nije uspelo!',
    fileDelete: 'Obriši ovu datoteku.',
    certificate_save_btn: 'Dodaj sertifikat na ',
    maze_path_info: 'Nema dostupnih puteva na grafu!',
    file_size_mb: 'Veličina datoteke mora biti manja od 25 MB!',
    reports: {
      products: 'Proizvodi',
      users: 'Korisnici',
      ph_username: 'Pretraži korisnika po korisničkom imenu',
      ph_id: 'Pretraži korisnika po ID broju',
      ph_email: 'Pretraži korisnika po e‑pošti'
    },
    select_upload_section_id: 'Datoteka za sekciju je obavezna',
    tags_all: 'Svi',
    delete_file_confirm:
      'Da li ste sigurni da želite da obrišete ovu datoteku?',
    delete_file_title: 'Obriši datoteku',
    tooltip_publish: 'Objavi kurs sa izabranom opcijom',
    tooltip_save: 'Sačuvaj kurs sa trenutnim izmenama',
    tooltip_next: 'Idi na sledeće podešavanje kursa',
    tooltip_finish: 'Završi i sačuvaj trenutna ažuriranja',
    stories_modal: {
      title_upload: 'Otpremi priče',
      title_update: 'Ažuriraj priče',
      title_audio: 'Audio datoteka priče',
      btn_upload: 'Otpremi',
      btn_update: 'Ažuriraj',
      btn_close: 'Zatvori',
      btn_cancel: 'Otkaži',
      lbl_cover: 'Omot priče',
      rule_cover: 'Molimo otpremite omot za audio priču!',
      lbl_title: 'Naslov audio priče',
      rule_title: 'Unesite naslov audio priče!',
      lbl_description: 'Opis audio priče',
      rule_description: 'Unesite opis audio priče!',
      lbl_file: 'Otpremi audio datoteku priče',
      rule_file: 'Molimo otpremite audio datoteku priče!',
      rule_file_type: 'Molimo otpremite validnu audio datoteku priče!',
      lbl_select_file: 'Izaberite audio datoteku priče',
      msg_valid_file: 'Molimo izaberite validnu audio datoteku priče!',
      msg_success: 'Audio datoteka priče uspešno otpremljena',
      msg_failed: 'Nije uspelo dodeljivanje medijskih podataka!',
      msg_error: 'Greška pri otpremanju datoteke!'
    },
    audio_modal: {
      title_upload: 'Otpremi',
      title_update: 'Ažuriraj',
      title_audio: 'Audio datoteka',
      btn_upload: 'Otpremi',
      btn_update: 'Ažuriraj',
      btn_close: 'Zatvori',
      btn_cancel: 'Otkaži',
      lbl_cover: 'Omot audio zapisa',
      rule_cover: 'Molimo otpremite omot audio zapisa!',
      lbl_title: 'Naslov audio zapisa',
      rule_title: 'Unesite naslov audio zapisa!',
      lbl_description: 'Opis audio zapisa',
      rule_description: 'Unesite opis audio zapisa!',
      lbl_file: 'Otpremi audio datoteku',
      rule_file: 'Molimo otpremite audio datoteku!',
      rule_file_type: 'Molimo otpremite validnu audio datoteku!',
      lbl_select_file: 'Izaberite audio datoteku',
      msg_valid_file: 'Molimo izaberite validnu audio datoteku!',
      msg_success: 'Audio datoteka uspešno otpremljena',
      msg_failed: 'Nije uspelo dodeljivanje medijskih podataka!',
      msg_error: 'Greška pri otpremanju datoteke!'
    },
    info_episode: 'Naslovna slika epizode.',
    btn_delete_episode: 'Obriši ovu epizodu podkasta.',
    btn_edit_marketplace: 'Izmeni detalje marketplace-a.',
    btn_save_marketplace: 'Sačuvaj trenutne izmene.',
    btn_ai_podcast: 'Kreiraj AI podkast epizodu.',
    btn_upload_podcast: 'Otpremi sopstvenu audio epizodu podkasta.',
    attach_file: 'Otpremite datoteke da delite više sadržaja sa publikom',
    fileDownload: 'Preuzmi ovu datoteku.',
    singleEpishode: 'Epizoda',
    podcast_music: 'podkast, muzika i priče',
    publishHeader: 'Objavi podkaste, muziku i priče',
    editHeader: 'Uredi podkaste, muziku i priče',
    createHeader: 'Kreiraj podkaste, muziku i priče',
    marketplaceHeader: 'Detalji marketplace-a za podkaste, muziku i priče',
    message_marketplace: 'Molimo popunite marketplace obrazac!',
    create_podcast_live: 'Live podkast i muzika',
    create_podcast_custom: 'Prilagođeni podkast i muzika',
    create_podcast_stories: 'Priče',
    ai_Assisted_podcast_reation: 'Podkast i muzika uz AI podršku',
    publishTitle: 'Objavite podkaste, muziku i priče za javni pregled.',
    customButton: 'Kreiraj prilagođeno',
    customTitle: 'Sačuvaj izmene na podkastu.',
    updateButton: 'Ažuriraj',
    createButton: 'Kreiraj',
    createNewButton: 'Kreiraj novi',
    updateTitle: 'Ažurirajte detalje trenutnog podkasta, muzike i priča.',
    createTitle: 'Kreirajte novi podkast, muziku i priče',
    createNewTitle:
      'Novi podkast, muzika i priče biće kreirani na osnovu trenutnih unosa.',
    podcastTitle: 'Lista epizoda',
    podcastStoryTitle: 'Lista priča epizoda',
    podcastToolTipTitle: 'Lista epizoda podkasta',
    uploadAudio: 'Otpremi audio',
    aiAudio: 'AI audio',
    emptyPodcast: 'Još nema snimaka podkasta, muzike ili priča.',
    emptyStoriesPodcast: 'Nema dodatih priča.',
    emptyCreatePodcast: 'Molimo kreirajte podkast pre dodavanja audio zapisa.',
    playPodcast: 'Reprodukuj izabrani podkast, muziku i priče.',
    pausePodcast: 'Pauziraj izabrani podkast, muziku i priče.',
    selectPodcast: 'Izaberite ovaj podkast, muziku i priče.',
    downloadPodcast: 'Preuzmi ovaj audio.',
    uploadAudioFile: 'Otpremite novi audio i zamenite trenutni.',
    deleteConfirm: 'Da li ste sigurni da želite da obrišete ovaj audio?',
    roomName: 'Naziv podkasta',
    addGuestTitle: 'DODAJ GOSTA GOVORNIKA',
    showTime: 'Vreme emisije',
    startTime: 'Vreme početka',
    endTime: 'Vreme završetka',
    erorMsgImg: 'Molimo izaberite validnu sliku.',
    failedMsgImg: 'Neuspelo učitavanje slike. Molimo probajte ponovo!',
    failedMsgUpload: 'Greška pri otpremanju omota!',
    btnCoverUpload: 'Otpremi omot',
    is_private: 'Privatno',
    to_attach: 'Priloži datoteku',
    file_attached: 'Fajl priložen',
    main_event: 'Glavni događaj',
    event: 'Događaj',
    upload_pdf: 'Otpremi PDF',
    portrait: 'Portret',
    landscape: 'Pejzaž',
    import_from_library: 'Uvezi tekst iz medijske biblioteke',
    question_answer_ai: 'Pitanje/Odgovor AI',
    take_maze: 'POKRENI MetaMaze',
    training: 'Trening',
    select_transcribe_locale: 'Izaberite jezik za transkripciju',
    transcribe_limit: 'Unesite broj minuta za transkripciju',
    not_complete: 'Informacije o Marketplace-u nisu kompletne',
    complete: 'Informacije o Marketplace-u su kompletne',
    not_admin:
      'Potrebne su administratorske privilegije za objavu na Marketplace-u',
    no_course: 'Unesite naslov i izaberite sliku za aktivaciju Marketplace-a',
    scorm_not_complete:
      'Unesite naslov i izaberite sliku za otpremu SCORM fajla',
    not_found_maze: 'MetaMaze nije pronađen',
    email_require: 'E-mail adrese su obavezne',
    poll_required: 'Podaci iz ankete su obavezni',
    alert: 'Upozorenje!',
    warning: 'Upozorenje!',
    ok: 'U redu',
    cancel: 'Otkaži',
    done: 'Završeno',
    insert: 'Ubaci',
    private: 'Privatno',
    public: 'Javno',
    no_connection: 'Internet konekcija je izgubljena',
    switch: 'Prebaci',
    share_screen: 'Podeli ekran',
    stop_share_screen: 'Zaustavi deljenje ekrana',
    share_screen_with_camera: 'Podeli ekran sa kamerom',
    stop_share_screen_with_camera: 'Zaustavi deljenje ekrana sa kamerom',
    camera_on: 'Kamera uključena',
    camera_off: 'Kamera isključena',
    mic_on: 'Uključi mikrofon',
    mic_off: 'Isključi mikrofon',
    fullscreen: 'Ceo ekran',
    live_now: 'Uživo',
    schedule_on: 'Zakazano za',
    organisations: 'Organizacije',
    org_groups: 'Organizacione grupe',
    specific_user: 'Određeni korisnik',
    gif: 'GIF',
    unavailable: 'Nedostupno',
    yes: 'Da',
    no: 'Ne',
    event_duration_message: 'Maksimalno 300 minuta (5 sati)',
    send_email: 'Pošalji e-mail obaveštenje',
    admin_only: 'Samo za administratore',
    join: 'Pridruži se',
    leave: 'Napusti',
    share: 'Podeli',
    share_text: 'Unesite e-mail adresu osobe sa kojom želite da podelite fajl.',
    share_text_title: 'Podeli PDF',
    share_text_title_txt: 'Podeli tekst',
    select_users: 'Izaberite korisnike',
    delete: 'Obriši',
    attachment_event: 'Prilozi za događaj:',
    transcribe_limit: 'Minuti transkripcije',
    monthly_transcribe: 'Mesečni limit transkripcije:',
    enable_ai: 'Omogući AI:',
    enable_maze: 'Omogući MetaMaze:',
    media_service: 'Medijski servis',
    allow_others: 'Dozvoli drugima da uređuju',
    join_breakout_room: 'Uđi u izdvojenu sobu',
    bio: 'Biografija',
    linkedin: 'LinkedIn',
    select_org_report:
      'Pronađite i izaberite organizaciju za generisanje izveštaja.',
    org_image_not_found: 'Slika nije pronađena',
    insert_text: 'Ubaci tekst',
    insert_question_answer: 'Pitanje/Odgovor AI',
    modal_title2: 'Galerija Tekstova',
    my_text_library: 'Moja biblioteka tekstova',
    ai: 'AI',
    public_text_library: 'Javna biblioteka tekstova',
    organization_text_library: 'Organizaciona biblioteka tekstova',
    no_transcribed_text: 'Nema pronađenih transkribovanih tekstova',
    public_text_not_found: 'Javni transkribovani tekst nije pronađen',
    org_text_not_found: 'Organizacioni transkribovani tekst nije pronađen',
    org_video_not_found: 'Video nije pronađen',
    canva: 'Uradi preko Canva-e',
    canva_open: 'Kliknite ovde da otvorite Canva editor.',
    pdf: 'PDF',
    txt: 'TEKST',
    human: 'Premium',
    shared_file: 'Fajl je uspešno podeljen.',
    error_shared_file:
      'Došlo je do greške prilikom deljenja fajla. Pokušajte ponovo.',
    publish: 'Objavi',
    maze_scenes: 'MetaMaze scene',
    pexel_images: 'Pexel slike',
    group: 'Grupa',
    group_name: 'Naziv grupe',
    select_group: 'Izaberi grupu',
    search_maze: 'Pretraži MetaMaze',
    hosts: 'Domaćini',
    avg_score: 'Prosečan rezultat (%)',
    maze_report: 'Izveštaj o Maze-u',
    maze_view: 'Pregled Maze-a',
    title_maze: 'MetaMaze',
    author: 'Autor',
    match: 'Poklapanje puta',
    preview_mazeTitle: 'Naslov: ',
    other: 'Ostalo',
    total: 'UKUPNO',
    report_course: 'KURS',
    report_courses: 'KURSEVI',
    report_event: 'DOGAĐAJ',
    report_events: 'DOGAĐAJI',
    report_maze: 'MAZE',
    report_personalize_learning: 'PERSONALIZOVANO UČENJE',
    report_live_assessment: 'PROCENA UŽIVO',
    report_live_assessments: 'PROCENE UŽIVO',
    report_skill_journey: 'PUT VEŠTINA',
    skill_journey: 'Put veština',
    skill_journeys: 'Putevi veština',
    date: 'DATUM: ',
    search_people: 'Pretraga osoba',
    passed: 'POLOŽIO',
    failed: 'NIJE POLOŽIO',
    item: 'STAVKA',
    type: 'TIP',
    minimum_pass_score: 'MINIMALAN BROJ BODOVA ZA PROLAZ',
    resources_count: 'BROJ RESURSA',
    back: 'NAZAD',
    resources: 'RESURSI',
    time_spent: 'UTROŠENO VREME (MINUTA)',
    detail: 'DETALJI',
    watched_time_mins: 'VREME GLEDANJA (MINUTA)',
    personalize_learning: 'Personalizovano učenje',
    result: 'Rezultat',
    assessment_title: 'Naslov',
    marketPlace_graph: 'Grafikon Marketplace-a',
    attachments: 'Dodatni prilozi',
    new_scorm_course: 'Otpremi novi SCORM kurs',
    upload_scorm_course: 'Otpremi SCORM kurs',
    new_maze: 'Kreiraj novi MetaMaze',
    new_skill_journey: 'Kreiraj Put veština',
    tags_scorm: 'SCORM',
    tags_skillJourney: 'Put veština',
    new_discussion_room: 'Kreiraj novi podkast',
    title: 'Šta želite da radite danas?',
    build_course: 'Kreiraj moj kurs',
    live_broadcast: 'Prenos uživo',
    invite_users: 'Pozovi korisnike u moju organizaciju',
    build_voice_over: 'Kreiraj moju naraciju',
    view_reports: 'Pogledaj izveštaje',
    upload_media: 'Otpremi moj medijski sadržaj ili rad i podeli ga',
    main_menu: 'Glavni meni',
    get_started: 'ZAPOČNI',
    search_group: 'Pretraži organizacionu grupu',
    ai_course: 'AI kurs',
    search_user: 'Pretraži naziv kompanije',
    no_maze: 'Trenutno nema MetaMaze sadržaja.',
    conference_event_title: 'Konferencijski događaji',
    conference_event_subTitle: 'Završeni konferencijski događaji',
    conference_event: 'Trenutno nema konferencijskih događaja.',
    no_skill: 'Trenutno nema puteva veština.',
    no_podcast: 'Trenutno nema podkasta.',
    maze_channel: 'MetaMaze',
    past_live_assessment: 'Prethodne procene uživo',
    no_live_assessment: 'Trenutno nema procena uživo.',
    enrolled_courses: 'Kursevi',
    my_video_channel: 'Moji video kanali',
    enrolled_liveEvents: 'Događaji uživo',
    sharebot: 'Sharebot',
    selected_language: 'Izabrani jezik',
    shareSphere_game: 'ShareSphere igra',
    maze: 'MetaMaze',
    skill: 'Put veština',
    channel: 'Kanal',
    order: 'Porudžbina',
    is_record: 'Snimanje',
    no_maze_found: 'MetaMaze nije pronađen.',
    maze_self_limit_reached: 'Dostignut je limit za samoprocenu u MetaMaze.',
    metamaze_two_times: 'Već ste dva puta rešavali ovaj MetaMaze.',
    metamaze_two_times_no_result:
      'Već ste dva puta rešavali ovaj MetaMaze. Rezultat se neće beležiti nakon druge samoprocene.',
    scorm_zip: 'SCORM ZIP',
    pass_score: 'Minimalan broj poena za prolaz',
    organization: 'Molimo izaberite organizaciju',
    pass_score_mark: 'Unesite broj poena između 1 i 100',
    maze_cloning_success: 'MetaMaze "<0/>" je uspešno kloniran!',
    create_certificate: 'Kreiraj sertifikat',
    create_badge: 'Kreiraj bedž',
    certificate_added: 'Sertifikat je dodat.',
    badge_added: 'Bedž je dodat.',
    certificate_warning:
      'Sertifikat/bedž nije moguće menjati nakon objavljivanja!',
    created_course_plan: 'Uredi i objavi svoj kurs i isplaniraj događaje uživo',
    market_place_space: 'Marketplace',
    select_course_language: 'Izaberi jezik (opciono)',
    select_language: 'Izaberi jezik',
    file_upload: 'Otpremanje fajla',
    text: 'Ovde unesite tekst…',
    attempts_count: 'Broj pokušaja koje korisnik može imati',
    no_of_people_placeholder: 'Broj osoba',
    back_to_maze: 'Nazad na MetaMaze scenario',
    edit_maze: 'Uredi Maze',
    wait: 'Sačekajte...',
    retry: 'Pokušaj ponovo',
    publish_scorm_course: 'Objavi svoj SCORM kurs',
    publish_maze: 'Objavi svoj MetaMaze',
    import: 'Uvezi elemente',
    answer_correct: 'Izaberite tačan odgovor',
    author_name: `Unesite ime autora`,
    select_category: 'Izaberite kategoriju',
    course_outline: 'Unesite plan kursa',
    course_obj: 'Unesite ciljeve kursa',
    course_description: 'Unesite opis kursa',
    maze_outline: 'Unesite plan lavirinta',
    maze_obj: 'Unesite ciljeve lavirinta',
    maze_description: 'Unesite opis lavirinta',
    lessons: 'Unesite broj lekcija',
    user_email_require: `Email korisnika je obavezan`,
    team_size: `Veličina tima je obavezna`,
    enter_price: 'Unesite cenu (5 ili više)',
    input_title_maze: 'Unesite naziv lavirinta',
    trainer_bio: 'Unesite biografiju trenera',
    trainer_linkedin: 'Unesite LinkedIn profil trenera',
    error_video: 'Unesite broj video snimaka',
    input_video_link: 'Unesite link do videa',
    number_of_video: 'broj videa',
    number_of_lessions: 'broj lekcija',
    no_of_people_in_conference: 'Koliko ljudi učestvuje u konferenciji?',
    transcribe_settings: 'Podešavanja transkripcije',
    transcribe: 'Transkribuj',
    cloning_maze: 'Kloniranje MetaMaze-a...',
    id_number: 'ID broj',
    timezone: 'Vremenska zona',
    edit_maze: 'Uredi',
    delete_maze: 'Obriši',
    view_maze: 'Pregled',
    create_metamaze: 'Kreiraj MetaMaze',
    metamaze_scenario: 'Scenarijo MetaMaze-a',
    publish_metamaze: 'Podešavanja objave',
    search_result: 'Rezultati pretrage:',
    search_for: 'Pretraga za',
    search_no_result: '- Nema dostupnih rezultata!',
    channel_no_available: 'Kanal nije dostupan!',
    this_card: 'Ovo je kartica',
    course_no_available: 'Nema dostupnih kurseva!',
    exit_fullscreen: 'Izađi iz celog ekrana',
    bg_image: 'Pozadinska slika',
    introduction: 'Uvod',
    summary: 'Rezime',
    generate_introduction: 'Generiši uvod',
    generate_summary: 'Generiši rezime',
    bullet_points: 'Tačke nabrajanja',
    title_simulation: 'Unesite naziv simulacije',
    view_generated_images: 'Pregled generisanih slika',
    image_transparency: 'Transparentnost slike',
    template_bg_color: 'Boja pozadine šablona',
    select_template_layout: 'Izaberite raspored šablona',
    reload_template: '(Ponovo učitaj šablone)',
    are_you_sure_want_close: 'Da li ste sigurni da želite da zatvorite?',
    all_your_changes_will_be_lost: 'Sve vaše izmene će biti izgubljene.',
    please_checked_before_generated_video:
      'Molimo vas da potvrdite da su svi uslovi ispunjeni pre generisanja videa.',
    voice_must_be_selected: 'Morate izabrati glas',
    avatar_must_be_selected: 'Morate izabrati sliku avatara.',
    maximum_five_slides_try_again:
      'Greška pri izvlačenju slika iz fajla. Uverite se da fajl sadrži najviše 5 slajdova i da svaki sadrži beleške. Pokušajte ponovo!',
    back_to_upload: 'Nazad na otpremanje',
    uploading_file_to_server: 'Otpremanje fajla na server',
    extracting_images_from_your_file: 'Izvlačenje slika iz vašeg fajla',
    upload_your_ppt_or_drag:
      'Otpremite vašu PowerPoint prezentaciju (.PPTX) ili je prevucite ovde.',
    maximum_five_slides_error:
      'Uverite se da PowerPoint fajl sadrži najviše 5 slajdova sa beleškama. U suprotnom će doći do greške.',
    number_of_questions_generated: 'Broj generisanih pitanja',
    quiz_page_this_cannot_be_done:
      'Da li ste sigurni da želite da dodate kviz na ovu stranicu? Ovo se ne može poništiti.',
    confirm_selection: 'Potvrdi izbor',
    select_quiz_page: 'Izaberite stranicu za kviz',
    lesson_do_you_want_add_this_quiz:
      'Na koji deo lekcije želite da dodate ovaj kviz?',
    beginning_of_lesson: 'Na početku lekcije',
    end_of_lesson: 'Na kraju lekcije',
    currently_active_page: 'Trenutno aktivna stranica',
    finish: 'Završi',
    upload_selection_file: 'Otpremi fajl sekcije',
    general_quiz: 'Opšti kviz',
    manage_sequence: 'Upravljaj redosledom',
    save_sequence: 'Sačuvaj redosled',
    new: 'Novi',
    in_progress: 'U toku',
    recommended_course: 'Preporučeni kurs',
    up_coming: 'Uskoro',
    past_live: 'Završeni uživo prenosi',
    input_your_channel_name: 'Unesite ime vašeg kanala!',
    organization_place: 'Tržište organizacije',
    marketplace_report: 'Izveštaj tržišta',
    story_writing: 'Pisanje priče',
    Ai_quiz: 'AI kviz',
    generate_quiz: 'Generiši kviz',
    create_story: 'Kreiraj priču',
    change_layout_page: 'Menjate raspored ove stranice.',
    change_layout_message:
      'Napomena: biće sačuvani samo tekst, slike, pozadina i logo. Svi ostali elementi će biti uklonjeni.',
    reviews: 'Recenzije',
    tab_attachments: 'Prilozi',
    zoom_in: 'Uvećaj',
    zoom_out: 'Umanji',
    zoom_reset: 'Resetuj zumiranje',
    no_attachment: 'Nema priloga.',
    select_upload_simulation: 'Izaberite/otpremite simulaciju.',
    quiz_updated_successfully: 'Kviz je uspešno ažuriran!',
    quizes: 'Kvizovi',
    trivia: 'Zanimljivosti',
    closing: 'Zatvaranje...',
    products: 'Proizvodi',
    ask_questions: 'Postavi pitanje ovde...',
    course_information: 'Informacije o kursu',
    course_assistance: 'Pomoć kreatoru kursa',
    go_back: 'Nazad',
    ai_generate_content_progress: 'Napredak u generisanju sadržaja',
    view_generate_content: 'Pregledaj generisani sadržaj',
    generate_error: 'Greška pri generisanju!',
    confirm_creating_course:
      'Da li želite da potvrdite kreiranje kursa sa ovim sadržajem?',
    generate_content_automatically:
      'Ovo će automatski dodati sav generisani sadržaj kao lekcije i stranice u vaš kurs.',
    quiz_created_successfully: 'Kviz je uspešno napravljen!',
    create_quiz: 'Kreiraj kviz',
    quiz_setting: 'Podešavanja kviza',
    please_fill_quiz_setting:
      '* Molimo popunite sva polja u podešavanjima kviza',
    question_list: 'Lista pitanja',
    add_quiz_to_page: 'Dodaj kviz na stranicu',
    form_create_question: 'Forma za kreiranje pitanja',
    user_information_updated: 'Podaci o korisniku su ažurirani!',
    your_stripe_activete_to_continue:
      'Vaš Stripe nalog nije aktivan. Molimo povežite ili aktivirajte da nastavite.',
    connect_tripe: 'Poveži Stripe',
    certificate_sent_sucessfully: 'Sertifikat je uspešno poslat na vaš email.',
    error_try_again: 'Greška. Pokušajte ponovo!',
    error_delete_channel: 'Došlo je do greške prilikom brisanja kanala.',
    error_update_sub: 'Greška prilikom ažuriranja pretplate.',
    end_time_cannot_start: 'Vreme završetka ne može biti pre vremena početka.',
    start_date_time_interval: 'Obavezna je početna datum i vremenski interval!',
    podcast_updated_successful: 'Podcast je uspešno ažuriran.',
    podcast_created_successful: 'Podcast je uspešno kreiran.',
    podcast_published_successful: 'Podcast je uspešno objavljen.',
    podcast_cover_updated: 'Omot podcasta je ažuriran.',
    new_podcast_details:
      'Na osnovu trenutnog podcasta i unosa kreiraće se novi podcast.',
    current_update_podcast: 'Ažuriraj trenutni podcast, muziku i priče.',
    create_new_podcast: 'Kreiraj novi podcast',
    publish_podcast_public_view: 'Objavi podcast za javni prikaz.',
    only_allowed_twenty_five_email: 'Dozvoljeno je samo 25 email adresa.',
    only_allowed_five_email: 'Dozvoljeno je samo 5 email adresa.',
    cover_is_required: 'Omot je obavezan.',
    topic_is_required: 'Tema je obavezna.',
    delete_schedule: 'Obriši raspored',
    make_as_coaching: 'Označi kao dostupno za koučing',
    manage_category: 'Upravljanje kategorijom',
    threshold: 'Prag',
    threshold_popup:
      'Prag u procentima (%), nakon čega se aktivira preporuka za određenu kategoriju.',
    list_of_catagory: 'Lista kategorija',
    category_name: 'Naziv kategorije',
    category_threshold: 'Prag kategorije',
    play_game: 'Igraj igricu',
    switching_organization: 'Menjanje organizacije...',
    coaching_session: 'Sesija koučinga',
    required_channel_id: 'ID kanala je obavezan!',
    error_occured_try_again: 'Došlo je do greške. Pokušajte ponovo!',
    please_complete_marketplace_form:
      'Molimo popunite formular za marketplace!',
    upload_file_corrupt: 'Otpremljeni fajl je oštećen.',
    course_not_published: 'Kurs još nije objavljen!',
    error_request: 'Greška u zahtevu. Molimo pokušajte ponovo!',
    skill_request: 'Molimo popunite obavezna polja!',
    error_occured: 'Došlo je do greške. Pokušajte ponovo!',
    show_time: 'Prikaži vreme',
    start_time: 'Vreme početka',
    end_time: 'Vreme završetka',
    room_name: 'Naziv podcasta',
    add_guest_speaker: 'Dodaj gostujućeg govornika',
    cover_picture: 'Slika omota',
    guest_speaker: 'Gostujući govornik',
    see_more: 'Prikaži više',
    see_less: 'Prikaži manje',
    background: 'Pozadina',
    icon: 'Ikona',
    icon_size: 'Veličina ikone',
    icon_color: 'Boja ikone',
    only_text: 'Samo tekst',
    change_bg: 'Promeni boju pozadine',
    bg_color: 'Boja pozadine',
    font_size: 'Veličina fonta',
    normal: 'Normalno',
    change_color: 'Promeni boju teksta',
    slant_text: 'Naginjani tekst',
    text_radius: 'Radijus teksta',
    vertical_align: 'Vertikalno poravnanje',
    horizontal_align: 'Horizontalno poravnanje',
    change_icon_color: 'Promeni boju ikone',
    upload_icon: 'Otpremi ikonu',
    upload_signature: 'Otpremi potpis',
    add_another_sign: 'Dodaj drugi potpis',
    name_badges: 'Naziv znački',
    should_less_150: 'mora biti 150 karaktera ili manje',
    your_badge: 'Tvoja značkica',
    do_you_want_delete_badge: 'Da li želite da obrišete ovu značkicu?',
    do_you_want_delete_cert: 'Da li želite da obrišete ovaj sertifikat?',
    upload_logo: 'Otpremi logo',
    name_of_cert: 'Naziv sertifikata',
    upload_cert: 'Ažuriraj sertifikat',
    your_cert: 'Tvoj sertifikat',
    translate_to: 'Prevedi na',
    select_file_attach: 'Izaberi fajl za prikačenje',
    certificate: 'Sertifikat',
    badge: 'Značka',
    publish_options: 'Opcije objavljivanja',
    publish_skills_journey: 'Objavi putovanje veština',
    videos: 'Video zapisi',
    generate_ai_video:
      'Proces generisanja videa može potrajati. Bićete obavešteni putem emaila kada bude gotov.',
    trainer_information: 'Informacije o treneru',
    promotional_video_link: 'Link promotivnog videa',
    please_select: 'Molimo izaberite',
    image_name: 'Naziv slike:',
    image_size: 'Veličina slike:',
    charecters_fifteen_less: '15 karaktera ili manje',
    leadership: 'Liderstvo',
    text_arc: 'Luk teksta',
    vertical: 'Vertikalno',
    horizontal: 'Horizontalno',
    badge_history: 'Istorija značkica',
    templates: 'Šabloni',
    sign: 'Potpis',
    logo: 'Logo',
    certificate_history: 'Istorija sertifikata',
    please_wait: 'Molimo sačekajte...',
    information: 'Informacija',
    support_five_thousand_live_event: 'Podržava do 5000 učesnika na događaju',
    support_ten_live_event: 'Podržava do 10 učesnika na live video',
    we_will_back_participant:
      'Vraćamo se sa događajem koji podržava više učesnika.',
    course_objectives: 'Ciljevi kursa',
    course_outlines: 'Plan kursa',
    price_dollor: 'cena (usd)',
    not_completed: 'Nije završeno',
    enable_marketplace: 'Omogući Marketplace',
    enable_course_ai: 'Omogući kreiranje kursa uz AI',
    enable_report_to_admin: 'Omogući izveštaje za admina',
    enable_white_label: 'Omogući White Label',
    enable_eleven_labs_for_maze_play: 'Omogući Elevenlabs za Maze Play',
    enable_eleven_labs_for_maze_play_cloned:
      'Omogući klonirani glas Elevenlabs',
    simulation_quiz: 'Simulacioni kviz',
    bg_color_setting: 'Podešavanje boje pozadine',
    color_preview: 'Pregled boje',
    choose_new_color: 'Izaberi novu boju',
    remove_color: 'Ukloni boju',
    apply_color: 'Primeni boju',
    elemeent_in_a_sceenario_page:
      'Ne možete dodati drugi element na stranicu scenarija. Pokušajte drugu stranicu ili prvo uklonite scenario.',
    no_data_found: 'Nema pronađenih podataka.',
    references: 'Reference',
    open_file: 'Otvori fajl',
    showing_result: 'Prikazuje rezultat:',
    fiften_day_free_trail: '15 dana besplatne probe',
    your_browser_does_not_support: 'Vaš pregledač ne podržava audio element.',
    podcast_desc: 'Opis podkasta',
    input_podcast_desc: 'Unesite opis podkasta',
    podcast_obj: 'Ciljevi podkasta',
    input_podcast_obj: 'Unesite ciljeve podkasta',
    podcast_outline: 'Pregled podkasta',
    input_podcast_outline: 'Unesite pregled podkasta',
    add_file: 'Dodaj fajl',
    generate_podcast_audio: 'Generiši audio podkasta',
    generate_uploaded_file_input_parameter:
      'Generiše sadržaj na osnovu postavljenih fajlova i unetih parametara.',
    go_backe_generation_state: 'Vrati se na stanje generisanja sadržaja.',
    create_ai_powered_podcast:
      'Kreiraj epizodu(e) podkasta uz pomoć veštačke inteligencije i generisanog zvuka.',
    generate_voice_for_all_podcast:
      'Molimo generišite glas za sve epizode podkasta',
    create_podcast_episode: 'Kreiraj epizodu podkasta',
    voice_name: 'Ime glasa',
    input_custom_name: 'Unesite prilagođeno ime!',
    enter_custom_name: 'Unesite ime glasa po izboru',
    upload_complete: 'Postavljanje završeno',
    uploading_in_progress: 'Postavljanje u toku...',
    podcast_stream_content: 'Sadržaj strimovanog podkasta',
    upload_podcast_cover: 'Molimo postavite naslovnu sliku podkasta!',
    enter_podcast_name: 'Unesite naziv podkasta!',
    podcast_topic: 'Tema podkasta',
    enter_podcast_topic: 'Unesite temu podkasta!',
    enter_podcast_desc: 'Unesite opis podkasta!',
    number_of_speaker: 'Broj govornika',
    select_the_number_of_speaker: 'Izaberite broj govornika!',
    number_of_episode: 'Broj epizoda',
    input_number_of_episode: 'Unesite broj epizoda!',
    podcast_length: 'Dužina podkasta',
    select_the_podcast_length: 'Izaberite dužinu podkasta!',
    short_podcast: 'Kratak (5–10 min)',
    medium_podcast: 'Srednji (15–18 min)',
    long_podcast: 'Dug (18+ min)',
    name_of_host: 'Ime voditelja',
    enter_host_name: 'Unesite ime voditelja!',
    guest_name: 'Ime gostiju',
    enter_guest_name: 'Unesite ime gosta!',
    choose_speaker_tone: 'Izaberite ton govornika',
    enter_speaker_tone: 'Izaberite ton podkasta!',
    informal: 'Neformalan',
    formal: 'Formalan',
    serious: 'Ozbiljan',
    light_humor: 'Blag humor',
    casual: 'Ležeran',
    select_content_source: 'Izaberite izvor sadržaja',
    from_internet: 'Sa interneta',
    upload_pdf_internet: 'Postavi PDF ili interni dokument',
    note: 'Napomena:',
    podcast_content_will_be_automatically_generated:
      'Sadržaj podkasta će biti automatski generisan korišćenjem proverenih izvora sa interneta.',
    upload_or_select_file: 'Molimo postavite ili izaberite fajl(ove)!',
    podcast_eposode_title: 'Naslov epizode podkasta',
    enter_podcast_title: 'Unesite naslov epizode!',
    podcast_episode_des: 'Opis epizode podkasta',
    enter_podcast_episode_des: 'Unesite opis epizode!',
    voice: 'Glas',
    music: 'Muzika',
    select_music: 'Izaberite muziku',
    play_the_music: 'Pusti muziku',
    stop_the_music: 'Zaustavi muziku',
    context: 'Kontekst',
    generate_audio_content_selected_voice:
      'Ovo će generisati audio sadržaj prema izabranim glasovima.',
    required_field_before_submitting:
      'Molimo popunite sva obavezna polja pre slanja.',
    regenerate_voice: 'Ponovo generiši glas',
    generate_voice: 'Generiši glas',
    your_browser_does_not_suppot: 'Vaš pregledač ne podržava audio element.',
    are_sure_leave_podcast: 'Da li ste sigurni da želite da napustite podkast?',
    broadcast_ongoing:
      'Emitovanje je u toku. Da li zaista želite da napustite ovu stranicu?',
    brodcaster_unavailable: 'Emitovanje trenutno nije dostupno.',
    setting_calender_for_booking: 'Podešavanje kalendara za rezervaciju',
    add_calender: 'Dodaj kalendar',
    waiting_join_host: 'Čeka se da se voditelj priključi...',
    no_reviews_found: 'Nema recenzija.',
    rated_already: 'Već ste ocenili ovaj događaj uživo.',
    downlink_png: 'preuzmi_png',
    downlink_jpg: 'preuzmi_jpg',
    donwload_file_format: 'Izaberite format fajla koji želite da preuzmete.',
    crashed_event:
      'Ovaj događaj je prekinut. Potrebno je kreirati novi događaj. Izvinjavamo se zbog neprijatnosti.',
    prompt: 'Upit:',
    generated_image: '🚀 Generišem vašu sliku... Molimo sačekajte.',
    download_add: 'Preuzmi sve',
    setting_generator: 'Podešavanje generatora',
    enter_image_prompt: 'Unesite upit za sliku',
    image_prompt: 'Unesite upit za sliku',
    negative_prompt: 'Negativni upit',
    negative_image_prompt: 'Unesite negativni upit za sliku',
    number_output: 'Broj rezultata',
    enter_number_output: 'Unesite broj rezultata',
    image_style: 'Izaberite stil slike',
    output_format: 'Izlazni format',
    seeds: 'Seme',
    enter_seeds: 'Unesite broj semena',
    performance_mode: 'Režim performansi',
    quality: 'Kvalitet',
    speed: 'Brzina',
    balanced: 'Uravnotežen',
    guidance_scale: 'Skala navođenja',
    enter_guidance: 'Unesite skalu navođenja',
    select_image: 'Izaberite sliku.',
    image_prmt: 'Upit za sliku',
    generate_image_list_empty: 'Lista generisanih slika je prazna.',
    knowledge_center_tooltrip_des:
      'Dobijte precizne i koncizne odgovore na različita pitanja zahvaljujući AI modelu obučenom na raznovrsnim internet izvorima.',
    contexts: 'Konteksti',
    ai_processing_video_sharebot:
      'AI obrada video snimka će trajati oko 24 sata i biće prikazana na Sharebot-u.',
    remove_sharebot_video:
      'Ako želite da uklonite referencu videa sa Sharebot-a, obrišite odgovarajući transkript zajedno sa videom.',
    remove_sharebot_video_audio:
      'Brisanje transkripta će ukloniti referencu na video/zvuk iz Sharebot-a, ali video će ostati u medijskoj biblioteci/kanalu.',
    monthly_live_stream:
      'Za izmenu mesečnog limita za prenos uživo, obratite se',
    monthly_transcribe_limit:
      'Za izmenu mesečnog limita za transkripciju, obratite se',
    must_be_one_to_three_hundred: 'Mora biti između 1 i 300 minuta.',
    all_field_required: 'Sva polja su obavezna.',
    duration_minute: 'Trajanje (maksimalno 300 minuta)',
    gender: 'Pol',
    select_gender: 'Izaberite pol',
    accent: 'Akcenat',
    select_accent: 'Izaberite akcenat',
    create_voice: 'Kreiraj glas',
    enter_voice_name: 'Unesite ime glasa',
    select_voice_gender: 'Molimo izaberite pol glasa',
    upload_voice: 'Otpremite svoj glas',
    upload_voice_mp_three: 'Otpremite svoj glas (.mp3)',
    cloned_voice: 'Klonirani glasovi',
    voice_type: 'Tip glasa',
    select_voice_type: 'Izaberite tip glasa',
    sharelook_stand: 'Standardni',
    sharelook_premium: 'Premium',
    sharelook_custum_voice: 'Prilagođeni (kloniranje glasa)',
    create_auto_flow: 'Kreiraj automatski tok',
    how_many_layers: 'Koliko slojeva',
    verify_selection: 'Potvrdi izbor',
    uploaded_successful: 'Uspešno otpremljeno',
    upload_failed: 'Otpremanje nije uspelo',
    upload_only_five_mb: 'Otpremite sadržaj (PDF fajlovi, maksimalno 5)',
    docs_from_org_library: 'Koristite dokument iz organizacione biblioteke',
    failed_maze_generate: 'Neuspešna generacija lavirinta. Pokušajte ponovo.',
    generate_metamaze: 'Generisanje MetaMaze...',
    metamaze_being_generated:
      'Vaš MetaMaze se trenutno generiše. Bićete obavešteni putem e-pošte kada se proces završi.',
    metamaze_generate_successfully: 'MetaMaze uspešno generisan!',
    metamaze_with_proceed: 'Sada možete nastaviti sa MetaMaze-om.',
    ai_metamaze_generate: 'Generisanje MetaMaze putem veštačke inteligencije',
    what_kind_maze_create: 'Koju vrstu lavirinta želite da kreirate?',
    manual_metamaze_creation: 'Ručno kreiranje MetaMaze',
    manually_maze_customizing_scnario:
      'Ručno kreirajte lavirint prilagođavanjem scenarija i stabla opcija',
    maze_ai_generated:
      'Automatski generiši lavirint pomoću veštačke inteligencije',
    unmark_deadend: 'Ukloni oznaku ćorsokaka',
    mark_deadend: 'Označi kao ćorsokak',
    select_multiple_image_for_scenario:
      'Možete izabrati više slika za scenario.',
    select_your_image: 'Vaše izabrane slike',
    click_to_preview: 'Kliknite za pregled',
    are_you_sure_delete_image:
      'Da li ste sigurni da želite da obrišete ovu sliku?',
    select_image_from_library: 'Izaberite sliku iz medijske biblioteke',
    uploading_video: 'Otpremanje videa...',
    tree_node_type: 'Tip čvora stabla',
    correct_option_scenario: 'Tačna opcija ili scenario',
    incorrect_option: 'Netačna opcija',
    option_scenario_without_text: 'Opcija ili scenario bez teksta',
    dead_end: 'Ćorsokak (crveni okvir)',
    correct_path: 'Tačna putanja',
    incorrect_path_not_selected_correct_option_path:
      'Netačna putanja / putanja bez izabrane tačne opcije.',
    double_click_on_tree_node:
      'Dvostrukim klikom na čvor stabla, uređivač teksta automatski prikazuje njegov sadržaj.',
    add_scenario: 'Dodaj scenario',
    add_option: 'Dodaj opciju',
    an_error_occured: 'Došlo je do greške:',
    download_summary: 'Preuzmi rezime',
    step_wise_analysis: 'Analiza po koracima',
    step: 'Korak',
    upload_csv_file: 'Otpremi CSV fajl',
    download_template_to_import: 'Preuzmi uzorak šablona za uvoz',
    please_input_email: 'Unesite email adresu.',
    email_at_least_three_characters: 'Email mora imati najmanje 3 karaktera.',
    email_cannot_be_empty: 'Email ne može biti prazan.',
    input_email_in_new_line: 'Unesite email adrese (po jedna u svakom redu)',
    role: 'Uloga',
    select_role: 'Izaberite ulogu',
    select_group: 'Izaberite grupu',
    identification_number: 'Identifikacioni broj (opciono)',
    add_identification_number: 'Dodajte identifikacioni broj',
    pie_chart_of_all_categories:
      'Tortni grafikon svih kategorija na osnovu korišćenja na Sharelook-u.',
    total_sharesphere_question_answered_by_users:
      'Ukupan broj odgovorenih ShareSphere pitanja od strane korisnika u trenutnoj organizaciji, sa rezultatima po kategorijama.',
    voice_style_over_the_text:
      'Ovde možete primeniti razne stilove glasa na tekst koji kucate. Lorem Ipsum je jednostavno fiktivni tekst u industriji štampe i izdavaštva.',
    input_your_question: 'Unesite svoje pitanje!',
    make_me_sales_manager: 'npr: Šta može da me učini menadžerom prodaje',
    enter_the_number_relevant_document: 'Unesite broj relevantnih dokumenata',
    please_wait_loading_result: 'Sačekajte, učitavanje rezultata...',
    no_result_found: 'Nema rezultata. Pokušajte sa drugačijim pitanjem',
    browser_doesnot_support_iframes: 'Vaš pretraživač ne podržava iframe-ove',
    total_duration: 'Ukupno trajanje',
    number_of_messages: 'Broj poruka',
    search_result: 'Rezultati pretrage',
    count_result: '(1244 rezultata)',
    your_other_interests: 'Vaša druga interesovanja',
    your_total_score: 'Vaš ukupni rezultat',
    add_a_question: '+dodaj pitanje',
    travia_question_empty: 'Lista pitanja za Travia je prazna.',
    video_generation_is_on_queue: 'Vaš video je u redu za generisanje!',
    checking_video_status: 'Proveravanje statusa videa...',
    total_quizzes: 'Ukupan broj kvizova',
    number_of_votes: 'Broj glasova',
    total_events: 'Ukupan broj događaja',
    number_of_rates: 'Broj ocena',
    number_of_likes: 'Broj sviđanja',
    all_courses: 'Svi kursevi',
    total_questions: 'Ukupno pitanja',
    no_skill_journey: 'Nema dostupnog puta učenja veština!',
    search_no_results: '- nema rezultata!',
    no_image_generated: 'Nema generisanih slika!',
    all_topic_in_this_lesson:
      'Sve teme u ovoj lekciji biće obrisane. Ovo se ne može opozvati.',
    content_has_been_generated: 'Sadržaj je generisan za ovu temu.',
    update_course_template: 'Ažuriraj šablon kursa',
    add_course_template: 'Dodaj šablon kursa',
    create_course_now: 'Kreiraj kurs sada',
    preview_course: 'Pregled kursa',
    layout: 'Raspored',
    import_from_youtube: 'Uvezi sa YouTube-a',
    my_media_library: 'Moja medijska biblioteka',
    bg_added: 'Pozadina dodata',
    add_bg: 'Dodaj pozadinu',
    booked_schedule: 'Zakazan raspored',
    add_schedule: 'Dodaj raspored',
    are_you_delete_schedule:
      'Da li ste sigurni da želite da obrišete ovaj raspored?',
    add_task: 'Dodaj zadatak',
    update_calender: 'Ažuriraj kalendar',
    manage_cookies: 'Upravljanje kolačićima',
    cookie_banner_text:
      'Koristimo kolačiće kako bismo poboljšali vaše iskustvo pregledanja, analizirali saobraćaj sajta i personalizovali sadržaj. Vaša privatnost nam je važna.',
    accept_all_cookies: 'Prihvati sve kolačiće',
    reject_all: 'Odbij sve',
    customize: 'Prilagodi',
    cookie_preferences_title: 'Podešavanja kolačića i privatnosti',
    privacy_subtitle:
      'Vaša privatnost nam je važna. Odaberite sa kojim kolačićima ste saglasni. Ova podešavanja možete promeniti u bilo kom trenutku.',
    save_choices: 'Sačuvaj moj izbor',
    strictly_necessary: 'Strogo neophodni',
    strictly_necessary_desc:
      'Ovi kolačići su neophodni za pravilno funkcionisanje sajta. Omogućavaju osnovne funkcije kao što su navigacija po stranici, slanje formulara i pristup zaštićenim oblastima. Sajt ne može pravilno da funkcioniše bez njih.',
    analytics_performance: 'Analitika i performanse',
    analytics_performance_desc:
      'Ovi kolačići nam pomažu da razumemo kako posetioci koriste naš sajt prikupljanjem i anonimnim izveštavanjem informacija. To pomaže da poboljšamo performanse sajta i korisničko iskustvo.',
    advertising_marketing: 'Oglašavanje i marketing',
    advertising_marketing_desc:
      'Ovi kolačići se koriste kako bi reklamne poruke bile relevantnije za vas. Sprečavaju stalno ponavljanje iste reklame i osiguravaju pravilno prikazivanje oglasa za oglašivače.',
    tracking_social: 'Praćenje i društvene mreže',
    tracking_social_desc:
      'Ovi kolačići omogućavaju dodatne funkcije i personalizaciju sadržaja, kao što su funkcije društvenih mreža i personalizovani sadržaj. Mogu biti postavljeni od strane nas ili trećih lica.',
    functional: 'Funkcionalni',
    functional_desc:
      'Ovi kolačići omogućavaju dodatne funkcionalnosti poput chat podrške, live pomoći i drugih interaktivnih opcija koje poboljšavaju vaše iskustvo na sajtu.',
    your_rights: 'Vaša prava:',
    rights_description:
      'Možete povući svoj pristanak u bilo kom trenutku, pristupiti svojim podacima ili zahtevati njihovo brisanje u bilo kom trenutku.',
    withdraw_consent: 'Povuci sve pristanke',

    how_many_options: 'Koliko opcija',
    add_content: 'Dodaj sadržaj',
    downloads_center: 'Centar za preuzimanje',
    sharelook_help_center: 'Sharelook Centar pomoći',
    channel_outline: 'Pregled kanala',
    channel_objectives: 'Ciljevi kanala',
    no_sop_available: 'Lista SOP-a nije dostupna.',
    generate_world_summary: 'Generiši scenario',
    world_scenario: 'Scenario stvarnog sveta',
    drag_icon_hint: 'Savet: Prevucite ikonu po platnu da biste je postavili',
    drag_text_hint: 'Savet: Prevucite tekst po platnu da biste ga postavili',
    edit_badge: 'Izmeni značku',
    create_new_badge: 'Nova značka',
    select_video_preview: 'Izaberite video za pregled',
    certificate_title_required: 'Naziv sertifikata je obavezan',
    discard_changes: 'Odbaci promene',
    edit_certificate: 'Izmeni sertifikat',
    add_another_logo: 'Dodaj još jedan logo',
    optional: 'Opcionalno',
    doc: 'DOC',
    ppt: 'PPT',
    quest_title: 'Kreiraj novi zadatak',
    quest_filter_title: 'Zadatak',
    sharelook_assistance: 'Sharelook pomoć',
    upload_scorm_zip: 'Otpremi Scorm Zip',
    only_letters_numbers_space_dot_allowed:
      'Dozvoljena su samo slova, brojevi, razmaci i tačke!',
    video_playing: 'Reprodukuje se',
    course_price_message:
      '*Kurs će biti dostupan samo korisnicima unutar organizacije i ne može se preprodavati na tržištu.',
    lesson_must_be_positive: 'Broj lekcija mora biti veći od 1',
    btn_proceed: 'Nastavi',
    rule_select_music: 'Molimo izaberite muziku',
    course_info: 'Informacije o kursu',
    content_selection: 'Izbor sadržaja',
    course_content_source: 'Izvor sadržaja kursa',
    choose_how_to_source: 'Odaberite kako ćete pribaviti sadržaj za ovaj kurs:',
    automatic_selection: 'Automatski izbor',
    system_will_automatically_select_relavant_documents:
      'Sistem će automatski izabrati relevantne dokumente iz vaše biblioteke',
    manual_selection: 'Ručni izbor',
    choose_specific_documents_from_your_library:
      'Odaberite konkretne dokumente iz vaše biblioteke',
    upload_files: 'Otpremi fajlove',
    upload_new_documents:
      'Otpremite nove dokumente (PDF, DOC, DOCX, PPT, PPTX, TXT) - Maksimalno 5 fajlova',
    file: 'fajl',
    ready_to_upload: 'spremno za otpremanje',
    clear_all: 'Očisti sve',
    confirm_course_wide_premiew: 'Potvrdi pregled kursa u celini',
    generate_course_preview: 'Generiši pregled kursa',
    instructions_across_the_course_to_generate:
      'Primenićemo vaše instrukcije na ceo kurs da generišemo pregled. Prvo proverite sve, zatim odlučite da li ćete sačuvati ili odbaciti promene.',
    instruction_to_preview_course_wide:
      'Instrukcije za pregled kursa u celini:',
    edit_content: 'Izmeni sadržaj',
    manage_course_template: 'Upravljanje šablonom kursa',
    undo: 'Poništi',
    apply_changes: 'Primeni promene',
    characters: 'karaktera',
    apply_all: 'Primeni sve',
    apply_to_all: 'Primeni na sve',
    use_this_content: 'Koristi ovaj sadržaj',
    original: 'Original',
    edited: 'Izmenjeno',
    edited_content_preview: 'Pregled izmenjenog sadržaja',
    apply_edits_to_all_topices: 'Primeni izmene na sve teme?',
    current_editing_instructions_across_the_whole_course:
      'Ovo će primeniti vaše trenutne instrukcije na ceo kurs. Možete pregledati kombinovani pregled pre nego što sačuvate.',
    edit_content_instructions: 'Instrukcije za uređivanje sadržaja',
    generate_content_for_this_topic_instruction:
      'Generiši sadržaj za ovu temu prema vašim instrukcijama',
    descrip_edit_content:
      'Opišite kako urediti ovaj sadržaj (npr. skratiti, pojednostaviti, preformulisati)',
    try_short_clear_direcctives:
      'Koristite kratke i jasne instrukcije. Primeri: „skratiti na 100 reči, sačuvati ključne tačke“, „pojednostaviti jezik“, „učiniti kraćim i ukloniti suvišno“.',
    we_preserve_the_core_meaning:
      'Zadržavamo osnovno značenje prilikom primene vaših instrukcija.',
    feedback_optional: 'Povratna informacija (opciono)',
    write_your_feedback_here: 'Opišite vašu povratnu informaciju ovde',
    from_web: 'Sa web-a',
    from_desktop: 'Sa računara',
    pleae_wait_processing: 'Molimo sačekajte obradu...',
    create_simulation_from_screen_capture:
      'Kreiraj simulaciju sa snimka ekrana',
    sharelook_not_found: 'ShareLook nije pronađen',
    sharelook_screen_capture_application_not_be_opened:
      'ShareLook Screen Capture aplikacija se nije mogla otvoriti. Možda nije instalirana na vašem računaru.',
    download_sharelook: 'Preuzmi ShareLook',
    launch_sharelook_application: 'Pokreni ShareLook aplikaciju',
    this_will_open_the_sharelook_application_for_screen_capture:
      'Ovo će otvoriti ShareLook aplikaciju za snimanje ekrana.',
    sharelook_dosenot_open:
      'Ako ShareLook ne otvara, možda nije instaliran na vašem računaru.',
    open_sharelook: 'Otvori ShareLook',
    download_app: 'Preuzmi aplikaciju',
    background_image_setting: 'Podešavanja pozadinske slike',
    current_image: 'Trenutna slika',
    change_image: 'Promeni sliku',
    remove_image: 'Ukloni sliku',
    no_background_image_selected: 'Nijedna pozadinska slika nije izabrana',
    add_image: 'Dodaj sliku',
    this_will_open_for_screen_recording:
      'Ovo će otvoriti ShareLook aplikaciju za snimanje ekrana.',
    ai_image_generation: 'Generisanje AI slike',
    image_edit: 'Uređivanje slike',
    text_to_image: 'Tekst u sliku',
    output_gallary: 'Galerija rezultata',
    instant_generation: 'Spremno za instant generisanje',
    prompt_and_unleash_the_power: 'Unesite prompt i oslobodite moć',
    use_this_image: 'Koristi ovu sliku',
    error_generating: 'Greška pri generisanju.',
    generation_tips: 'Saveti za generisanje',
    detailed_descriptions_for_more_accurate_results:
      'Koristite detaljna objašnjenja za preciznije rezultate',
    reference_image: 'Referentna slika',
    select_pixel_image: 'Izaberite piksel sliku',
    max_mb: 'Maksimum 50MB',
    please_enter_text_to_appear_image:
      'Unesite tekst koji će se pojaviti na slici',
    enter_text_to_apear_in_the_image:
      'Unesite tekst koji će se pojaviti na slici',
    generate_image: 'Generiši sliku',
    prompt_assistant: 'Asistent za prompt',
    generate_image_using_suggested_prompt:
      'Generiši sliku koristeći predloženi prompt',
    talk_to_ai_about_the_image_generate:
      'Razgovarajte sa AI o slici koju želite da generišete',
    ask_for_prompt_suggestions: 'Zatraži predloge prompta...',
    enter_a_search_term_to_find_stock_images:
      'Unesite pojam za pretragu za stock slike',
    choose_your_content_source: 'Izaberite izvor sadržaja:',
    upload_new_document_from_your_device:
      'Otpremite nove dokumente sa vašeg uređaja',
    automatic_library_selection: 'Automatski izbor iz biblioteke',
    system_automatically_selects_relevant_document:
      'Sistem automatski bira relevantne dokumente',
    manual_library_selection: 'Ručni izbor iz biblioteke',
    generate_content: 'Generiši sadržaj',
    add_to_current_page: 'Dodaj na trenutnu stranicu',
    generate_bullet_points: 'Generiši ključne tačke',
    generating: 'Generiše se',
    this_may_take_a_few_moments: 'Ovo može potrajati nekoliko trenutaka',
    apply_to_page: 'Primeni na stranici',
    scenario_escription: 'Opis scenarija:',
    feedback: 'Povratna informacija',
    form_mode: 'Režim forme',
    chat_mode: 'Režim četa',
    this_will_generate_a_continuation_of_the_seleccted_story:
      'Ovo će generisati nastavak odabrane priče koristeći AI.',
    continue_this_story_question: 'Nastaviti ovu priču?',
    continue_this_story: 'Nastaviti ovu priču',
    what_will_happen: 'Šta će se desiti:',
    the_ai_will_analyze_the_existing_story_content:
      'AI će analizirati postojeći sadržaj priče',
    generate_a_natural_continuation_that_follows_the_same_tone:
      'Generiši prirodan nastavak koji prati isti ton i stil',
    create_new_content_that_build_upon_the_current_narrative:
      'Kreirajte novi sadržaj koji nadograđuje trenutnu naraciju',
    this_process_may_take_a_few_moments_to_complete:
      'Ovaj proces može potrajati nekoliko trenutaka.',
    no_existing_stories_found_for_this_course:
      'Nema postojećih priča za ovaj kurs.',
    create_your_first_story: 'Kreirajte svoju prvu priču',
    existing_stories: 'Postojeće priče',
    create_new_story: 'Kreiraj novu priču',
    tone: 'Ton',
    style: 'Stil',
    genre: 'Žanr',
    loading_your_stories: 'Učitavanje vaših priča...',
    edit_story: 'Izmeni priču',
    story_preferences: 'Postavke priče',
    please_input_your: 'Molimo unesite vaš',
    add_character_names_and_press_enter:
      'Dodajte imena likova i pritisnite Enter',
    select_or_type_your: 'Izaberite ili unesite vaš',
    enter_your: 'Unesite vaš',
    position_of_the_story_in_the_lesson:
      'Pozicija priče u lekciji. Priča će biti dodata kao blok na određenu poziciju.',
    save_previous_content_on_the_pages:
      'Sačuvaj prethodni sadržaj na stranicama',
    the_existing_content_in_the_selected_pages:
      'Postojeći sadržaj na odabranim stranicama biće zamenjen generisanom pričom.',
    real_world_scenario: 'Scenario iz stvarnog sveta',
    add_optional_instructions:
      'Dodajte opcionalna uputstva (ton, dužina, publika, itd.)',
    ready_to_enerate_your_real_world_scenario:
      'Spremno za generisanje vašeg scenarija iz stvarnog sveta',
    click_generate_real_world_scenario_to_create_a_realistic_scenario:
      'Kliknite "Generiši scenario iz stvarnog sveta" da kreirate realističan scenario na osnovu sadržaja vaše lekcije.',
    the_ai_will_analyze_your_lesson_topic_and_content:
      'AI će analizirati temu i sadržaj vaše lekcije',
    generate_a_practical_real_world_scenario:
      'Generiši praktičan scenario iz stvarnog sveta',
    you_can_then_edit_and_customize_the_result:
      'Zatim možete uređivati i prilagođavati rezultat',

    add_it_as_a_new_page_to_your_lesson:
      'Dodajte kao novu stranicu u vašu lekciju',
    regenerate_with_instructions: 'Generiši ponovo sa uputstvima',
    add_real_world_scenario: 'Dodaj scenario iz stvarnog sveta',
    generate_real_world_scenario: 'Generiši scenario iz stvarnog sveta',
    simulation_has_been_stopped: 'Simulacija je zaustavljena!',
    loading_simulation: 'Učitavanje simulacije...',
    you_have_exhausted_all_the_attempts: 'Iskoristili ste sve pokušaje',
    study_the_scenario_on_this_page_and_select_the_correct_answer:
      'Proučite scenario na ovoj stranici i izaberite tačan odgovor iz opcija ispod.',
    attempts_limit_reached:
      'Dostigli ste limit pokušaja. Možete igrati ponovo, ali vaš rezultat neće biti sačuvan.',
    play_again: 'Igraj ponovo',
    import_music_from_computer: 'Uvezi muziku sa računara.',
    more: 'više',
    no_badge_yet: 'Još nema bedževa',
    competition_filter: 'Filter takmičenja',
    global_leaderboard: 'Globalna tabela lidera',
    placeholder_for_the_global_leaderboard:
      'Ovo je rezervisano mesto za globalnu tabelu lidera.',
    badge_editor: 'Editor bedževa',
    adjust_the_appearance_of_this_badge_icon:
      'Podesite izgled ove ikone bedža. Promene važe samo za ovaj bedž.',
    badge_style: 'Stil bedža',
    the_image_must_be_pixels: 'Slika mora biti 200x200 piksela.',
    badge_name: 'Ime bedža',
    badge_descrription: 'Opis bedža',
    enter_badge_criteria: 'Unesite kriterijume bedža',
    discard: 'Odbaci',
    badge_enable: 'Bedževi omogućeni',
    award_users_with_badges_to_highlight_the_milestones:
      'Nagradite korisnike bedževima da istaknete ključne prekretnice u njihovom učenju.',
    badge_types: 'Tipovi bedževa',
    enable_or_disable_specific_badge_types_for_your_users:
      'Omogućite ili onemogućite određene tipove bedževa za vaše korisnike.',
    levels_enabled: 'Nivoi omogućeni',
    level_rules: 'Pravila nivoa',
    points: 'Poeni',
    add_new_level: 'Dodaj novi nivo',
    add_level: 'Dodaj nivo',
    points_enabled: 'Poeni omogućeni',
    learning_activities_and_encourage_healthy_competition:
      'Nagradite korisnike poenima za različite aktivnosti učenja i podstičite zdravu konkurenciju.',
    award_points: 'Dodeli poene',
    the_following_equates_the_value_of_one_item_completion:
      'Sledeće je ekvivalent vrednosti završetka jednog zadatka',
    general: 'Opšte',
    others: 'Ostalo',
    certificate: 'Sertifikat',
    quiz_passed: 'Kvize završen',
    tip_approved: 'Savet odobren',
    tip_liked: 'Savet lajkovan',
    rewards: 'Nagrade',
    offer_discounts_when_learners_achieve:
      'Ponudite popuste kada učenici postignu određeni broj poena, bedževa ili nivoa.',
    give_rewards: 'Dodeli nagrade',
    discount_course_purchases_by: 'Popust na kupovinu kursa za',
    with_points_more_than: 'sa više poena od',
    with_badges_more_than: 'sa više bedževa od',
    with_level_upwards_more_than: 'sa nivoom iznad',
    leaderboard: 'Tabela lidera',
    leaderboard_enabled: 'Tabela lidera omogućena',
    leaderboards_offer_users_an_overview_of_their_learning_progress:
      'Tabele lidera korisnicima daju pregled njihovog napretka u učenju u odnosu na druge.',
    show_levels: 'Prikaži nivoe',
    show_points: 'Prikaži poene',
    show_badges: 'Prikaži bedževe',
    show_courses: 'Prikaži kurseve',
    show_certificates: 'Prikaži sertifikate',
    leaderboard_settings: 'Podešavanja tabele lidera',
    set_up_engaging_leaderboard_experiences_to_boost_learner_motivation:
      'Postavite zanimljive tabele lidera da povećate motivaciju učenika.',
    award_users_with_points_for_different_learning_activities:
      'Nagradite korisnike poenima za različite aktivnosti učenja.',
    badge_set: 'Set bedževa',
    choose_the_type_of_badges_your_users:
      'Izaberite tip bedževa koje će korisnici osvajati tokom učenja.',
    levels: 'Nivoi',
    Levels_represent_the_stages:
      'Nivoi predstavljaju faze u korisnikovom putu učenja.',
    enabled: 'Omogućeno',
    disabled: 'Onemogućeno',
    quick_select: 'Brzi izbor',
    yesterday: 'Juče',
    last_week: 'Prošle nedelje',
    Last_month: 'Prošli mesec',
    last_quarter: 'Prošli kvartal',
    historical_leaderboard: 'Istorijska tabela lidera',
    track_your_performance_and_see_how_you_rank_among_your_peers:
      'Pratite svoj napredak i vidite kako ste rangirani među vršnjacima',
    time_period: 'Vremenski period',
    page_of: 'Strana 1 od 1',
    edit_competition: 'Izmeni takmičenje',
    create_competition: 'Kreiraj takmičenje',
    arrow_right: 'strelica-desno',
    update_competition: 'Ažuriraj takmičenje',
    competition_title: 'Naslov takmičenja',
    enter_competition_title: 'Unesite naslov takmičenja',
    enter_competition_description: 'Unesite opis takmičenja',
    leaderboard_skill: 'Veština',
    select_a_skill: 'Izaberite veštinu',
    no_skills_found: 'Nema pronađenih veština',
    competition_period: 'Period takmičenja',
    add_badge_rule: 'Dodaj pravilo za bedž',
    create_badge: 'Kreiraj bedž',
    add_level_rule: 'Dodaj pravilo nivoa',
    selected_participants: 'Odabrani učesnici',
    no_participants: 'Nema učesnika',
    start_end_date: 'Datum početka–završetka',
    created_date: 'Kreirao',
    new_competition: 'Novo takmičenje',
    competitions_list: 'Lista takmičenja',
    search_competitions: 'Pretraži takmičenja...',
    are_you_sure_you_want_to_delete_the_competition:
      'Da li ste sigurni da želite da obrišete takmičenje',
    history: 'Istorija',
    export: 'Izvoz',
    search_by_name: 'Pretraži po imenu...',
    no_historical_data_available_for_the_selected_period:
      'Nema istorijskih podataka za izabrani period.',
    no_leaderboard_data_available: 'Nema dostupnih podataka tabele lidera.',
    competitions: 'Takmičenja',
    leaderboards: 'Tabele lidera',
    welcome_back: 'Dobrodošli nazad',
    track_your_performance_and_see: 'Pratite svoj napredak i vidite svoj rang',
    team_leaderboard: 'Tabela lidera tima',
    try_again: 'Pokušaj ponovo',
    no_competitions_for_search: 'Nema dostupnih takmičenja za',
    no_competitions_available: 'Nema dostupnih takmičenja',
    no_competitions_matching_search:
      'Nema takmičenja koja odgovaraju vašoj pretrazi. Pokušajte sa drugim pojmovima ili proverite kasnije.',
    no_competitions_general:
      'Trenutno nema postavljenih takmičenja. Proverite kasnije ili kontaktirajte administratora za kreiranje novih takmičenja.',
    media_management: 'Upravljanje medijima',
    badgess_set: 'Set bedževa',
    choose_the_default_visual_style_for_badge:
      'Izaberite podrazumevani vizuelni stil ikona bedževa korišćenih na platformi.',
    enable_badges: 'Omogući bedževe',
    add_badge: 'Dodaj bedž',
    min: 'Min',
    max: 'Maks',
    your_rank: 'Vaš rang',
    your_points: 'Vaši poeni',
    your_level: 'Vaš nivo',
    rank: 'Rang #',
    level: 'Nivo',
    progress: 'Napredak',
    new_folder: 'Nova fascikla',
    file_upload: 'Otpremi fajl',
    writer: 'Autor',
    text_documents: 'Tekstualni dokumenti',
    spreadsheets: 'Tabele',
    impress: 'Prezentacija',
    presentations: 'Prezentacije',
    capture_desktop_screen: 'Snimi ekran računara',
    capture_desktop_screens: 'Snimi ekrane računara',
    your_documents: 'Vaši dokumenti',
    manage_your_videos_images_audio_files:
      'Upravljajte svojim video, slikovnim i audio fajlovima i drugim resursima korišćenim u kreiranju sadržaja.',
    your_organization_documents: 'Dokumenti vaše organizacije',
    keep_your_organization_creative_assets_organized:
      'Održavajte kreativne resurse vaše organizacije organizovanim i dostupnim—optimizujte timski rad i produkciju sadržaja.',
    your_public_documents: 'Vaši javni dokumenti',
    curated_collection_of_media_assets_available:
      'Kurirana kolekcija medijskih resursa dostupna za sve—istražujte, ponovo koristite i kreirajte.',
    your_download_center_documents: 'Dokumenti vašeg centra za preuzimanje',
    repository_of_approved_media_assets_for_download:
      'Repozitorijum odobrenih medijskih resursa za preuzimanje i korišćenje u projektima.',
    search_files_and_folders: 'Pretraži fajlove i fascikle..',
    home: 'Početna',
    folders: 'Fascikle',
    folder_name: 'Ime fascikle',
    owner: 'Vlasnik',
    last_updated: 'Poslednje ažurirano',
    action: 'Akcija',
    no_folders_found: 'Nema fascikli',
    files: 'Fajlovi',
    enabling_ai: 'Omogućavanje AI...',
    rename: 'Preimenuj',
    copy: 'Kopiraj',
    move: 'Premesti',
    verson_history: 'Istorija verzija',
    manage_permission: 'Upravljanje dozvolama',
    generate_audit_report: 'Generiši izveštaj revizije',
    last_edited: 'Poslednja izmena',
    no_files_found: 'Nema fajlova',
    are_you_sure_you_want_to_make_this_item_public:
      'Da li ste sigurni da želite da ovaj element učinite javnim? Biće kopiran u vašu javnu biblioteku.',
    move_to_organization: 'Premesti u organizaciju',
    are_you_sure_you_want_to_copy_this_item_to_your_organization_library:
      'Da li ste sigurni da želite da kopirate ovaj element u biblioteku vaše organizacije?',
    are_you_sure_you_want_to_make_this_item_private:
      'Da li ste sigurni da želite da ovaj element učinite privatnim? Biće kopiran u vašu ličnu biblioteku.',
    date_modified: 'Datum izmene',
    workflow_management: 'Upravljanje radnim tokovima',
    configure_editors_approvers_and_viewers_for_this_document:
      'Konfigurišite urednike, odobravaoce i posmatrače za ovaj dokument.',
    error_Loading_editor: 'Greška pri učitavanju editora',
    debug_info: 'Informacije za otklanjanje grešaka',
    loading_editor: 'Učitavanje editora...',
    submitted_for_review: 'Poslato na pregled',
    editors: 'Urednici',
    no_editors_added_yet:
      'Još nema dodanih urednika. Kliknite "Dodaj urednika" za dodavanje.',
    add_editor: 'Dodaj urednika',
    approvers: 'Odobravaoci',
    no_approvers_added_yet:
      'Još nema dodanih odobravaoca. Kliknite "Dodaj odobravaoca" za dodavanje.',
    add_approvers: 'Dodaj odobravaoca',
    viewer: 'Posmatrač',
    no_viewers_added_yet:
      'Još nema dodanih posmatrača. Kliknite "Dodaj posmatrača" za dodavanje.',
    add_viewer: 'Dodaj posmatrača',
    are_you_sure_you_want_to_delete_the_selected_items:
      'Da li ste sigurni da želite da obrišete odabrane elemente?'
  },
  v3: {
    reportShareSphere: 'Deljenje sfere',
    overview: 'Pregled kategorije',
    triviaReport: 'Kategorija ShareSphere',
    overviewGraph: 'Grafikon pregleda kategorije',
    category: 'Kategorija',
    phCategory: 'Izaberite kategoriju',
    podcast: 'Podcast, muzika i priče',
    pastPodcast: 'Prošli podcasti',
    upcomingPodcast: 'Predstojeći podcasti',
    podcastLanguageTitle: 'Jezik podcasta, muzike i priča',
    podcastLanguageCheckbox: 'Koristi AI za jezik mog podkasta',
    howRate: 'Kako ocenjujete ovaj podcast?',
    podcastSubmit: 'Pošalji',
    podcastGuest: 'Gost govornik:',
    podcastReview: 'Recenzije',
    podcastEpishode: 'Epizoda',
    podcastEnd: 'Podcast završen',
    date_podcast: 'Datum podcasta',
    skill_not_found: 'Izvinite! Putanja veština nije pronađena.',
    coaching: 'Trening',
    webinar: 'Vebinar',
    public_conference: 'Javna konferencija',
    skill_journey_subtitle:
      'Podesite svoj put veština i izaberite ko može da ga vidi i sa njim komunicira.',
    enable_white_label: 'Omogući White Label',
    create_new_event_org: 'Kreiraj novi događaj za vašu organizaciju',
    create_new_event_marketplace: 'Kreiraj novi događaj za market',
    create_new_event_both: 'Kreiraj novi događaj za vašu organizaciju i market',
    event_outline: 'Unesite skicu događaja',
    event_obj: 'Unesite ciljeve događaja',
    event_description: 'Unesite opis događaja',
    create_new_metamaze_org: 'Kreiraj novi MetaMaze za vašu organizaciju',
    create_new_metamaze_marketplace: 'Kreiraj novi MetaMaze za market',
    create_new_metamaze_both:
      'Kreiraj novi MetaMaze za vašu organizaciju i market',
    add_key_words: 'Dodajte ključne reči',
    press_enter_make_keyword: 'Pritisnite Enter za kreiranje ključne reči',
    disable_skip_quiz: 'Onemogući preskakanje kviza',
    warning_complete_quiz: 'Molimo, završite kviz da biste nastavili.',
    signup_email_verification:
      'Poslali smo link za potvrdu na vaš e-mail. Molimo vas da kliknete na link da potvrdite registraciju.',
    verifying_registration: 'Verifikacija registracije naloga...',
    reset_password_linK:
      'Poslali smo link za resetovanje lozinke na vaš e-mail. Molimo vas da kliknete na link da podesite novu lozinku.',
    reset_email_error:
      'Korisnik sa tim e-mailom nije pronađen, pokušajte sa korisničkim imenom!',
    first_name: 'Ime',
    last_name: 'Prezime',
    error_firstName: 'Molimo unesite ime',
    error_sharebot_organization: 'Molimo unesite organizaciju',
    error_lastName: 'Molimo unesite prezime',
    private_conference: 'Privatna konferencija',
    public_conference: 'Javna konferencija',
    discussion_room: 'Soba za diskusiju',
    training_no_courses: 'Trenutno niste upisani ni na jedan kurs.',
    training_no_events: 'Trenutno ne učestvujete ni u jednom događaju.',
    allow_sharing_trainer_info: 'Dozvoli marketu da deli adresu e-pošte',
    error_username_space: 'Korisničko ime ne može sadržati razmake.',
    error_sharebot_organization_space:
      'Naziv organizacije ne može sadržati razmake.',
    edit_permission: 'Dozvola za uređivanje',
    valid_price: 'Cena mora biti veća od 0',
    course_price_message: `*Kursevi su dostupni samo korisnicima koji su ih kupili preko organizacije i ne mogu se preprodavati na marketu`,
    valid_edit_price: 'Cena za uređivanje mora biti manja od kupovne cene.',
    my_calendar: 'Moj kalendar',
    error_valid_firstName: 'Molimo unesite validno ime.',
    error_valid_organization: 'Molimo unesite validan naziv organizacije.',
    error_valid_lastName: 'Molimo unesite validno prezime.',
    error_name_spaces: 'Ime ne može sadržati razmake',
    items: 'Stavke',
    publish_to_channel: 'Objavi u mojoj kolekciji kanala',
    create_a_channel: 'Kreiraj moj kanal',
    create_a_trivia: 'Kreiraj kviz',
    create_a_new_channel: 'Kreiraj novi kanal',
    add_videos: 'Dodaj video snimke',
    save_and_continue: 'Sačuvaj i nastavi',
    channel: 'Kanal',
    channels: 'Kanali',
    view_channel: 'Pogledaj kanal',
    edit_channel: 'Izmeni kanal',
    delete_channel: 'Obriši kanal',
    my_video_channels: 'Moji video kanali',
    training_no_channel: 'Trenutno ne učestvujete ni u jednom kanalu.',
    monthly_price_required: 'Mesečna cena je obavezna',
    yearly_price_required: 'Godišnja cena je obavezna',
    one_time_price_required: 'Jednokratna cena je obavezna',
    marketplace_quantity: 'Dolari',
    report_webinar: 'Vebinar',
    report_coaching: 'Trening',
    report_channel: 'Kanal',
    report_public_conference: 'Javna konferencija',
    report_maze: 'Lavirint',
    channel: 'Kanal',
    edit_price: 'Izmeni cenu ($)',
    quantity: 'Količina',
    payment_type: 'Tip plaćanja',
    total_amount: 'Ukupan iznos ($)',
    net_amount: 'Neto iznos ($)',
    edit_option: 'Izmeni opciju',
    marketplace_price: 'Cena ($)',
    market_name: 'Ime',
    duration_min: 'Trajanje (minuti)',
    users_total: 'Korisnici (ukupno)',
    sales_total: 'Ukupna prodaja (dolari)',
    search_coaching: 'Pretraga treninga',
    search_channel: 'Pretraga kanala',
    search_webinar: 'Pretraga vebinara',
    search_maze: 'Pretraga lavirinta',
    search_public_conference: 'Pretraga javnih konferencija',
    buyer_type: 'Tip kupca',
    quanity: 'Količina',
    channel_unit_amount: 'Neto iznos ($)',
    channel_updated_at: 'Ažurirano',
    month_price: 'Cena (mesečno)',
    year_price: 'Cena (godišnje)',
    one_time_price: 'Cena (jednokratno)',
    sharebot_organization: 'Dodajte novi naziv organizacije',
    share_sphere: 'Deljenje sfere',

    limit_transcribe_text:
      'Preostalo vremena za transkripciju: <0>{{ transcribe_limit }}</0> minuta <1/><2/> <3>. Da biste promenili ograničenje za transkripciju, kontaktirajte </3> <4>admin@sharelook.com</4>.',
    you_donot_access_event: 'Nemate pristup ovom događaju.',
    ai_course_title_training: 'Kursevi obuke za lidere',
    ai_course_object: 'Navigacija liderstvom u digitalnom dobu',
    create_ai_video: 'Kreiraj AI video',
    generate: 'GENERISI',
    video_generate_process:
      'Proces generisanja videa može potrajati. Bićete obavešteni putem e-pošte kada bude završen.',
    stripe_account_connect:
      'Vaš Stripe nalog nije aktivan. Povežite ga ili aktivirajte da biste nastavili.',
    ai_creator: 'AI Kreator',
    check_video_status: 'Proveravanje statusa generisanja videa...',
    video_on_queue: 'Video je u redu za generisanje.',
    video_fail_generation:
      'Nažalost, generisanje videa nije uspelo. Pokušajte ponovo sa drugim videom.',
    video_currently_generated: 'Ovaj video se trenutno generiše.',
    checking_status: 'Proveravanje statusa',
    check_status: 'Proveri status',
    browser_does_not_support_audio: 'Vaš pregledač ne podržava audio tag',
    existing_edit_scenario:
      'Želite li da izmenite postojeći scenario ili da napravite novi? Ako kreirate novi, stari scenario će biti obrisan.',
    generate_scenario: 'Generiši Scenario',
    layout: 'Izgled',
    confirm_change: 'Potvrdi Promenu',
    generated_ai_creation_message:
      'Napomena: biće sačuvani samo tekstualni elementi generisani pomoću AI. Svi drugi elementi biće uklonjeni sa stranice.',
    generate_story: 'Generiši Priču',
    save_original_content: 'Sačuvaj originalni sadržaj:',
    story_added_specified_position:
      'Pozicija priče u lekciji. Priča će biti dodata kao blok na određenoj poziciji.',
    position_of_story: 'Pozicija priče',
    start_the_lesson: 'Početak lekcije',
    end_the_lesson: 'Kraj lekcije',
    add_story_pages: 'Dodaj priču na stranice',
    browser_does_not_support: 'Vaš pregledač ne podržava audio element.',
    no_video_available: 'Nema dostupnih videa.',
    no_podcast_available: 'Nema dostupnih podkasta.',
    no_item_baskets: 'Nema stavki u korpi.',
    ai_course_object: 'Navigacija liderstvom u digitalnom dobu',
    ai_course_title: 'Naziv Kursa',
    ai_input_course_title: 'Molimo unesite naziv kursa!',
    learning_objective_label: 'Cilj Učenja',
    learning_objective_message: 'Molimo unesite cilj učenja!',
    standard_question: 'Da li imate neki standard koji učenik treba da prati?',
    standard_details_label: 'Detalji Standarda',
    standard_details_message: 'Molimo unesite detalje standarda!',
    estimated_duration_label: 'Procenjena Trajanja Kursa (u minutima)',
    estimated_duration_message: 'Molimo unesite procenjenu trajanje!',
    min_duration_message: 'Minimalna trajanja je 5 minuta.',
    ai_mins: '25 min',
    industry_specific_question: 'Da li je specifično za industriju?',
    industry_label: 'Specificirajte Industriju',
    industry_message: 'Molimo unesite industriju!',
    ai_course_creation: 'Kreiranje Kursa sa AI',
    course_generated: 'Kurs Generisan od Sharelook',
    ai: 'AI',
    ai_you: 'Vi',
    ai_prompt_ready:
      'Vaš prompt je spreman. Sada ste spremni da generirate sadržaj.',
    ai_unable_respond:
      'Izvinjavam se! AI ne može da odgovori na vaš prompt. Molimo pokušajte ponovo.',
    ai_hide_toc: 'Sakrij Sadržaj',
    ai_preview_toc: 'Pregled Sadržaja',
    ai_generate_toc_now: 'Generiši Sadržaj Sada',
    ai_creation_course_title: 'Naziv Kursa:',
    ai_creation_industry_specific: 'Da Li Je Specifično za Industriju:',
    ai_creation_industry: 'Industrija:',
    ai_creation_standard_needed:
      'Da Li Imate Neki Standard Koji Učenik Treba Da Prati?:',
    ai_creation_standard_details: 'Detalji Standarda:',
    ai_creation_estimated_duration: 'Procenjena Trajanja Kursa (U Minutima):',
    minutes: 'minuta',
    ai_creation_learning_objective: 'Cilj Učenja:',
    setup_again: 'Podesi Ponovo',
    ai_creation_confirm_title:
      'Da li ste sigurni da želite da podesite formu ponovo?',
    ai_creation_confirm_content:
      'Čet i sav sadržaj koji ste generisali će biti resetovan.',
    ai_toc: 'Sadržaj',
    ai_note_topic:
      'Napomena: Možete prevlačiti i spuštati da promenite redosled tema unutar lekcije.',
    ai_add_topic: '+ Dodaj Temu',
    add_topic: 'Dodaj Temu',
    add_lesson: 'Dodaj Lekciju',
    add_new_lesson: 'Dodaj Novu Lekciju',
    ai_add_lesson: '+ Dodaj Lekciju',
    attention: 'Pažnja',
    before_varifying: 'Pre Verifikacije',
    ai_save_later: 'Sačuvaj za Kasnije',
    ai_download_word_doc: 'Preuzmi kao Word Dokument',
    ai_download_course_word_doc: 'Preuzmi Kurs kao Word Dokument',
    ai_create_course_button: 'Kreiraj Kurs',
    ai_generate_course_content: 'Generiši Sadržaj Kursa',
    ai_out_of: 'od',
    ai_subtopic_failed_content:
      'podteme nisu uspele da generišu sadržaj. Kliknite na "Generiši Sadržaj Kursa" ponovo da generirate sadržaj samo za te podteme.',
    ai_edit_topic: 'Uredi Temu',
    ai_edit_lesson_title: 'Uredi Naziv Lekcije',
    ai_save_topic: 'Sačuvaj Temu',
    ai_save: 'Sačuvaj',
    ai_save_lesson_title: 'Sačuvaj Naziv Lekcije',
    ai_add_new_topic: 'Dodaj Novu Temu',
    ai_download_ref: 'Preuzmi sa Reference',
    ai_download_ref_content:
      'Preuzmi će kurs kao Word dokument sa referencama.',
    ai_download_without_ref: 'Preuzmi bez Referenci',
    ai_download_two_word: 'Dva Word dokumenta će biti preuzeta:',
    ai_download_two_word_content_one:
      '- jedan koji sadrži glavni sadržaj bez referenci,',
    ai_download_two_word_content_two:
      'i drugi koji se sastoji samo od liste referenci bez dodatnog sadržaja.',
    ai_manage_content: 'Upravljaj Sadržajem',
    ai_add_content_from_internet: '+Dodaj Sadržaj sa Interneta',
    ai_confirm_start: 'Potvrdi Početak',
    ai_Verify: 'Verifikuj',
    ai_undo_warning:
      'Ovaj proces može potrajati. Molimo ne zatvarajte ovaj prozor dok se generisanje ne završi jer se ne može poništiti.',
    ai_verified_content:
      'Verifikovali ste sadržaj. Imajte na umu da nakon potvrde, nećete moći da se vratite na čet sa AI asistentom sa trenutnim sadržajem.',
    ai_want_proceed: 'Da li ste sigurni da želite da nastavite?',
    upload_simulation: 'Otpremi Simulaciju',
    name_simulation: 'Naziv Simulacije',
    selected_simulation_files: 'Odabrani Fajlovi Simulacije',
    score_between_one_hundred: 'Vaš rezultat treba biti između 1 i 100.',
    are_sure_simulation:
      'Da li ste sigurni da želite da obrišete ovaj fajl simulacije?',
    required_simulation: 'Rezultat je obavezan',
    required_section_file: 'Fajl sekcije je obavezan',
    simulation: 'Simulacija',
    simulation_quiz_games: 'Potrebno je dodati kviz u igre',
    simulation_alert_des:
      'Možete dodati igre samo ako sva pitanja imaju tip odgovora pojedinačni ili višestruki.',
    alert_info: 'informacija',
    ai_number_quiz: 'Broj Kvizova',
    ai_point: 'Poen',
    ai_points: 'Poeni',
    val_required: 'Obavezno',
    games: 'Igre',
    add_simulation: 'Dodaj Simulaciju',
    text_tiewer: 'Preglednik Teksta',
    back_to_account: 'Nazad na Nalog',
    delete_account: 'Obriši Nalog',
    delete_account_title: 'Obriši Nalog ???',
    delete_account_subtitle: 'Možete obrisati svoj nalog odavde.',
    delete_account_cannot_undo:
      'Spremni ste da obrišete svoj nalog. Ova akcija se ne može poništiti.',
    account_org_profile:
      'Takođe ćete izgubiti sve kurseve koje ste kreirali, profil vaše organizacije i sva vaša podešavanja.',
    deleting_account_database:
      'Brisanje vašeg naloga će ukloniti sve vaše podatke iz naše baze podataka.',
    account_confirm_delete:
      'Da li ste sigurni da želite da obrišete svoj nalog?',
    action_cannot_be_undone: 'Ova akcija se ne može poništiti.',
    account_delete_message_success: 'Vaš nalog je uspešno obrisan.',
    message_edit: 'Uredi',
    message_delete: 'Obriši',
    message_reply: 'Odgovori',
    attached_file: 'Priloženi Fajl',
    attach_file: 'Priloži Fajl',
    attach_des: '25 MB, maksimalna veličina fajla',
    view: 'Pogledaj',
    go_to_marketplace: 'Idi na Marketplace',
    learning_center: 'Centar za Učenje',
    knowledge_center: 'Centar Znanja',
    sharebot: 'ShareBot',
    sharebot_help_message: 'Kako vam mogu pomoći danas?',
    my_organization: 'Moja Organizacija',
    world_knowledge: 'Svetsko Znanje',
    welcome_to_sharelook: 'Dobrodošli u Sharelook!',
    sharelook_you_want_go: 'Gde želite da idete danas?',
    shareLook_learning_management_system:
      'Pristupite ShareLook sistemu za upravljanje učenjem da kreirate ili pristupite resursima za učenje kao što su uživo eventi i kursevi u vašoj organizaciji na ShareLook.',
    shareLook_powerful_ai_system:
      'Pristupite moćnom AI sistemu ShareLook-a gde možete otpremiti PDF dokumente i dobiti korisne uvide na dohvat ruke u sekundi. Dobijte brze odgovore na osnovu resursa otpremljenih u vašoj organizaciji ili dobijte odgovore iz našeg generičkog AI sistema u sekciji svetskog znanja.',
    edit_now: 'Uredi Sada',
    sharelook_log_out: 'Odjavljeni ste sa Sharelook. Molimo prijavite se!',
    sorry_error: 'Izvinjavam se! Doživeli smo neku grešku.',
    login: 'Prijavi se',
    refresh_page: 'Osveži Stranicu',
    just_a_moment: 'Samo Trenutak',
    enter_lname_fname: 'Molimo unesite svoje ime i prezime da nastavite.',
    procced_to_sharelook: 'Nastavi na Sharelook',
    option_one: 'Opcija 1',
    option_two: 'Opcija 2',
    selected_image: 'Odabrana Slika:',
    add_text: 'Dodaj Tekst',
    linkdin_is_required: 'LinkedIn je obavezan.',
    bio_is_required: 'Biografija je obavezna.',
    save_user_information: 'Sačuvaj Informacije Korisnika',
    select_all: 'Odaberi Sve',
    enable_ai: 'Omogući AI',
    load_more: 'Učitaj Više',
    channel_id: 'ID Kanala.',
    send: 'Pošalji',
    v4: 'Informacija',
    subscription: 'Pretplata',
    reset_user_flag: 'RESETUJ KORISNIČKU OZNAKU',
    delete_my_accont: 'Obriši moj nalog',
    sharebot_sub_error: 'Greška pri dohvatanju pretplata. Pokušajte ponovo!',
    sharebot_no_sub: 'Trenutno nemate aktivne pretplate.',
    sharebot_dont_sub: 'Nemate prethodne pretplate.',
    sharebot_prev_sub: 'Prethodno Pretplaćeno',
    sharebot_sub: 'ShareBot Pretplata',
    sharebot_un_sub: 'ShareBot Otkazivanje',
    sharebot_no_available: 'Nema Dostupnog Opisa',
    sharebot_start_date: 'Datum Početka:',
    sharebot_end_date: 'Datum Kraja:',
    sharebot_sure: 'Da li ste sigurni?',
    sharebot_do_you_want: 'Da li želite da',
    unsubscribe: 'otkažete pretplatu',
    unsubscribe_what: 'otkažete pretplatu?',
    subscribe: 'se pretplatite',
    subscribe_what: 'se pretplatite?',
    subscribe_now: 'Pretplatite se Sada',
    confirm: 'Potvrdi',
    sharebot_intel_knowledge_center: 'ShareBot Inteligentni Centar Znanja',
    sharebot_welcome_paragraph:
      'Dobrodošli u ShareBot Centar Znanja, napredni AI čet bot dizajniran da transformiše kako profesionalci pristupaju informacijama i sarađuju.',
    expired: 'Isteklo',
    active: 'Aktivno',
    Inactive: 'Neaktivno',
    yearly_subscription: 'Godišnja Pretplata',
    monthly_subscription: 'Mesečna Pretplata',
    no_sharebot_org: 'Nemate sharebot organizaciju',
    sharebot_start_free_trial: 'Počni Besplatnu Probnu Verziju',
    sub_month: 'Mesečna Pretplata',
    sub_year: 'Godišnja Pretplata',
    question_per_month: 'Skladištenjem Podataka (1TB) i 1000 Pitanja Mesečno',
    sharebot_para:
      'Nastavljanjem, potvrđujete trenutno brisanje organizacije. Ova akcija će rezultovati gubitkom svih vrednih uvida koje pruža ShareBot, i ne može se poništiti.',
    cancelled_date: 'Datum Otkazivanja:',
    live_straming_para:
      'Ako želite da promenite svoj mesečni limit za uživo strimovanje molimo kontaktirajte',
    sharelook_agree: 'Slažem se sa Sharelook',
    terms_condition: 'uslovima i odredbama',
    and: 'i',
    privacy_policy: 'politikom privatnosti',
    save_for_later: 'Sačuvaj za Kasnije',
    ai: 'AI',
    no_video_yet: 'Nijedan Video Nije Odabran Još!',
    are_you_sure_delete_video:
      'Da li ste sigurni da želite da obrišete ovaj video?',
    video_des: 'Opis',
    video_now: 'Sada',
    video_playing: 'Reprodukuje se:',
    video_no: 'Video Br.',
    ai_generated_course: 'AI Generisan Kurs',
    create_course_on_our_own: 'Kreiraj Kurs Samostalno',
    ai_Assisted_ourse_reation: 'AI Asistovano Kreiranje Kursa',
    pending: 'Na čekanju',
    published: 'Objavljeno',
    intro_course: 'u vaš kurs?',
    clone_course: 'Da li želite da klonirate',
    browser_audio_not_support: 'Vaš pregledač ne podržava audio tag.',
    audio_popup_content:
      'Gde možete koristiti mnoge stilove glasa preko teksta koji kucate bla bla bla Lorem Ipsum je jednostavno lažni tekst industrije štampe i slaganja. Lorem Ipsum je bio standardni lažni tekst industrije od 1500-tih,',
    close: 'Zatvori',
    podcast_rec: 'REC',
    create_podcast: 'Kreiraj Podcast',
    add_admin: 'DODAJ ADMIN',
    delete_all: 'Obriši sve',
    ai_podcast_audio: 'AI Podcast Audio',
    language: 'Jezik',
    podcast_download_content:
      '*Preuzmite AI audio fajl za uređivanje da postane vaš audio fajl.',
    upload_audio: 'Otpremi Audio',
    browser_do_not_support_audio: 'Vaš pregledač ne podržava audio element.',
    upload_cover: 'Otpremi Naslovnicu',
    upload_ai_creator: 'AI Kreator',
    required_cover_image: 'Slika naslovnice je obavezna!',
    room_required_name: 'Naziv Podcast-a je obavezan!',
    add_guest_list: 'Molimo dodajte listu gostiju!',
    podcast_add_participants: 'DODAJ UČESNIKA',
    topic_required: 'Potrebna je najmanje jedna tema',
    podcast_description: 'OPIS',
    podcast_date: 'DATUM',
    date: 'Datum',
    podcast_time: 'vreme',
    podcast_to: 'do',
    podcast_all_day: 'Ceo dan',
    podcast_start_date_time: 'Datum Početka i Vremenski Interval Su Obavezni!',
    podcast_id: 'ID',
    selected_user: 'Pozovi Odabrane Korisnike',
    see_more: 'Vidi Više',
    see_less: 'Vidi Manje',
    no_review_yet: 'Nema recenzije još, budite prvi koji će dati recenziju.',
    request_to_speak: 'Prihvatiti zahtev korisnika da govori?',
    kick_user: 'Da li želite da izbacite ovog korisnika?',
    accept_request: 'Prihvati Zahtev',
    kick: 'IZBACI',
    started: 'POČETO',
    end: 'KRAJ',
    join_now: 'Pridruži se Sada',
    podcast_end: 'Podcast je završen',
    connecting: 'povezivanje...',
    knowledge_center_know_today: 'Šta biste želeli da znate danas?',
    knowledge_center_question: 'Molimo prvo unesite pitanje',
    knowledge_center_error: 'Izvinjavam se! Doživeli smo neku grešku.',
    knowledge_center_tooltrip:
      'Dobijte brze odgovore iz resursa za učenje u repozitorijumu vaše organizacije na ShareLook, sa odgovarajućim referencama i mogućnošću pregleda i preuzimanja referentnih PDF dokumenata.',
    my_organization: 'Moja Organizacija',
    world_knowledge: 'Svetsko Znanje',
    open_file: 'Otvori Fajl',
    reference: 'Referenca',
    are_you_cancel: 'Da li ste sigurni da želite da otkažete?',
    are_you_remove_media: 'Da li ste sigurni da želite da uklonite medije?',
    terms_agree: 'Slažem se sa ovim',
    ready: 'Spreman',
    send_email: 'POŠALJI EMAIL',
    active_users: 'Aktivni korisnici',
    sign_up_user: 'Registrovani korisnici',
    non_sign_up_user: 'Neregistrovani korisnici',
    organisation: 'Organizacija',
    usage_report: 'Izveštaj o Korišćenju',
    check_email: 'proverite svoj email',
    delete_schedule: 'Obriši Raspored',
    are_you_sure_delete_schedule:
      'Da li ste sigurni da želite da obrišete ovaj raspored?',
    add_task: 'Molimo unesite zadatak!',
    coaching_available: 'Označi kao Dostupnost za Treniranje',
    message_booking_coaching:
      'Ovaj termin je rezervisan od strane korisnika za treniranje.',
    task_day: 'Dan Zadatka',
    created_task_day: 'Kreirali ste zadatak za ovaj dan.',
    event_day: 'Dan Događaja',
    has_booked_coaching: 'Treniranje je rezervisano za ovaj dan.',
    active_day: 'Aktivni Dan',
    selectable_time_slots:
      'Termini koji se mogu odabrati desno su aktivni za ovaj dan.',
    compare_last_month: 'U poređenju sa prošlim mesecom',
    uploading_file: 'Otpremanje vašeg fajla',
    attach_file_course: 'priložen ovom kursu.',
    fetch_request: 'Dohvatanje vašeg zahteva',
    finilize_upload: 'Finaliziranje otpremanja',
    scorm_scanned: 'Molimo sačekajte... Vaš otpremljeni SCORM zip se skenira.',
    scan_status: 'Status Skeniranja:',
    scan_completed: 'Skeniranje završeno. Vaš fajl je',
    scan_progress: 'Skeniranje u toku...',
    check_scorm: 'Proverava se format vašeg SCORM fajla... Molimo sačekajte...',
    file_check_success: 'Provera fajla uspešna',
    file_check_progress: 'Provera fajla u toku...',
    scorm_not_upload:
      'Vaš otpremljeni fajl nije SCORM 1.2 standard, molimo otpremite fajl ponovo.',
    select_question: 'Opcije Odgovora (odaberite jedan tačan odgovor)',
    select_answer: 'Molimo odaberite opciju odgovora!',
    check_option_one: 'Molimo unesite opciju jedan!',
    check_option_two: 'Molimo unesite opciju dva!',
    check_option_three: 'Molimo unesite opciju tri!',
    check_option_four: 'Molimo unesite opciju četiri!',
    question_image: 'Slika Pitanja',
    select_question_image: 'Molimo odaberite sliku pitanja!',
    ans_image: 'Slika Odgovora',
    upload_image_question: 'Otpremi Sliku Odgovora',
    select_image_answer: 'Molimo odaberite sliku odgovora!',
    save_question: 'Sačuvaj Pitanje',
    do_you_leave: 'Da li ste sigurni da želite da izađete?',
    loose_all_progress: 'Izgubićete sav svoj napredak.',
    welcome: 'Dobrodošli',
    team_knowledge_quest: 'Timska Potraga za Znanjem',
    your_score: 'Vaš Rezultat',
    start_playing: 'Počni Igru',
    share_sphere_complete: 'ShareSphere Završeno',
    final_score: 'Konačni Rezultat',
    play_next: 'Igraj Sledeće',
    you_donot_access_event: 'Nemate pristup ovom događaju.',
    ai_content_generated: 'Sadržaj je generisan za ovu temu.',
    ai_popup_confirm_content: 'Potvrdi Generisanje Sadržaja',
    limit_transcribe_text:
      'Minutos restantes de transcripción: <0>{{ transcribe_limit }}</0> minutos <1/><2/> <3>. Para cambiar tu límite de transcripción, por favor contacta con </3> <4>admin@sharelook.com</4>.',
    you_donot_access_event: 'No tienes acceso a este evento.',
    ai_course_title_training: 'Cursos de formación en liderazgo',
    ai_course_object: 'Navegando el liderazgo en la era digital',
    create_ai_video: 'Crear vídeo con IA',
    generate: 'GENERAR',
    video_generate_process:
      'El proceso de generación del vídeo puede tardar un poco. Recibirás un correo electrónico una vez finalizado.',
    stripe_account_connect:
      'Tu cuenta de Stripe está inactiva. Por favor, conéctala o actívala para continuar.',
    ai_creator: 'Creador con IA',
    check_video_status: 'Comprobando el estado de la generación del vídeo...',
    video_on_queue: 'El vídeo está en cola para ser generado.',
    video_fail_generation:
      'Lo sentimos, la generación del vídeo ha fallado. Intenta con otro.',
    video_currently_generated: 'Este vídeo se está generando actualmente.',
    checking_status: 'Comprobando estado',
    check_status: 'Comprobar estado',
    browser_does_not_support_audio:
      'Tu navegador no admite la etiqueta de audio',
    existing_edit_scenario:
      '¿Quieres editar el escenario existente o crear uno nuevo? Si creas uno nuevo, se perderá el anterior.',
    generate_scenario: 'Generar escenario',
    layout: 'Diseño',
    confirm_change: 'Confirmar cambio',
    generated_ai_creation_message:
      'Ten en cuenta que solo se conservarán los elementos de texto generados por IA. Todos los demás elementos se eliminarán de la página.',
    generate_story: 'Generar historia',
    save_original_content: 'Guardar contenido original:',
    story_added_specified_position:
      'La posición de la historia en la lección. Se añadirá como un bloque en la posición especificada.',
    position_of_story: 'Posición de la historia',
    start_the_lesson: 'Inicio de la lección',
    end_the_lesson: 'Fin de la lección',
    add_story_pages: 'Añadir historia a las páginas',
    browser_does_not_support: 'Tu navegador no admite el elemento de audio.',
    no_video_available: 'No hay vídeos disponibles.',
    no_podcast_available: 'No hay pódcasts disponibles.',
    no_item_baskets: 'No hay artículos en la cesta.',
    ai_course_object: 'Navegando el liderazgo en la era digital'
  },
  v2: {
    change: 'Promenite ',
    remove: 'Uklonite',
    auto_background: 'Automatska pozadina',
    create_new_course_org: 'Kreirajte novi kurs za Vašu organizaciju.',
    create_new_course_marketplace: ' Kreirajte novi kurs za tržište.',
    create_new_course_both:
      'Kreirajte novi kurs za Vašu organizaciju i za tržište.',
    ok: 'U redu',
    page_bg: 'Pozadina stranice',
    lesson_cover: ' Naslovna slika lekcija',
    create_skill_journey: ' Kreirajte obilazak veština',
    add_to_basket: ' Dodajte u korpu',
    basket: 'KORPA ',
    times: 'Puta',
    mazes: 'Lavirinti',
    events: 'Događaji',
    scroms: 'Scorm-ovi',
    min_score_pass: 'Minimalna ocena za prolaz',
    no_scorms_available: ' Nema dostupnih scorm-ova.',
    no_events_available: ' Nema dostupnih događaja.',
    no_courses_available: ' Nema dostupnih kurseva.',
    no_courses_baskets: 'Nema kurseva u korpi.',
    no_mazes_baskets: 'Nema lavirinata u korpi.',
    no_scroms_baskets: 'Nema scorm-ova u korpi.',
    no_events_baskets: ' Nema događaja u korpi.',
    option_1: 'Opcija 1',
    option_2: 'Opcija 2',
    enter_number_words: 'Unesite broj reči',
    summarize: ' Rezimirajte',
    answer: ' Odgovorite',
    hold_tight_one_minute:
      ' Sačekajte, još uvek se pripremamo. Može da potraje i do jednog minuta.',
    enter_question: ' Unesite pitanje',
    enter_relevant_documents: ' Unesite broj relevantnih dokumenata',
    please_input_relevant_documents: 'Unesite relevantan broj dokumenata!',
    please_wait_loading_results: 'Rezultati se učitavaju, molimo sačekajte…',
    proceed_to_add_voice: 'Nastavite da dodate glas',
    results: 'Rezultati',
    no_result_found_try_asking_questions:
      'Nema pronađenih rezultata, pokušajte da postavite još pitanja',
    eg: 'npr',
    what_make_sales_manager: 'Šta me može učiniti menadžerom prodaje',
    please_select_lang: 'Izaberite bilo koji jezik!',
    search: 'Pretraga',
    please_copy_desired_content:
      ' Kopirajte željeni sadržaj iz levog polja u desno polje.',
    rating_req: ' Ocena je obavezna.',
    review_req: ' Recenzija je obavezna.',
    rating_review_req: 'Ocena i recenzija moraju da se navedu.',
    how_rate_this: 'Kako biste ovo ocenili',
    amazing_above_expectations: 'Odlično, iznad očekivanja!',
    certificates: 'Sertifikati',
    you_no_certificates: ' Trenutno nema dostupnih sertifikata.',
    please_add_review: 'Molimo Vas da ostavite recenziju za ocenu, hvala.',
    post: 'Postavite',
    rate: 'Ocenite',
    avg_rating: 'Prosečna ocena',
    no_review_found: 'Nema recenzija',
    are_sure_to_disale_zoom_integration:
      'Da li ste sigurni da želite da onemogućite integraciju zumiranja?',
    badges: 'Bedzevi',
    you_no_badge_available: 'Trenutno nema dostupnih bedzeva.',
    download_certificate: 'Preuzmite sertifikat',
    loading: 'Učitavanje...',
    no_file_attached: 'Nema priloženih datoteka',
    sorry: 'Izvinite!',
    you_do_not_have_any_notes: 'Nemate beleške.',
    question: 'Pitanje',
    score: 'Rezultat',
    alert_score_message: 'Osoba je/su prosledili svoje rezultate.',
    alert_question_message: 'Do sada nije dodato ni jedno pitanje.',
    button_submit: 'Prosledite',
    button_allScores: 'Svi rezultati su prosleđeni.',
    record_wait: 'Snimanje počinje. Molimo sačekajte...',
    buttonSubmit_warning: 'Unesite sve rezultate pre prosleđivanja',

    // List.jsx @Added:Mahesh
    upload_ar_assets: 'Otpremite AR sredstva',
    edit_ar_assets: 'Uredite AR sredstva',
    upload_assets: 'Otpremite sredstva',

    // ARUploads.jsx @Added:Mahesh
    trigger_title: 'Naslov okidača',
    trigger_description: 'Opis okidača',
    please_type_target_description: 'Upišite opis cilja',
    trigger_image: 'Slika okidača*',
    upload_trigger_image: 'Otpremite sliku okidača',
    drag_n_drop: 'Prevucite i ispustite',
    file_size_should_not_exceed:
      '(Veličina datoteke ne bi trebalo da prelazi 2 MB)',
    ar_content: 'AR Sadržaj *',
    upload_3d_zip: 'Otpremite 3D Zip',
    content_attached: 'Sadržaj priložen.',
    enter_trigger_image_title: 'Unesite naslov slike okidača',
    ar_preview_image: 'AR Pregled slike',
    upload_preview_image: 'Otpremite sliku za pregled',
    creating___: 'Kreiranje...',
    updating___: 'Ažuriranje...',
    create: 'Kreirajte',
    update: 'Ažurirajte',
    ar_assets: 'AR Slika',
    _3d_files_mp4: '(Zipped .OBJ, .FBX)',
    persons_have_submitted_their_scores:
      ' Osoba je/su prosledili svoje rezultate.',
    no_questions_added_till_now: ' Do sada nije dodato ni jedno pitanje.',
    submit: 'Prosledite',
    all_scores_submitted: 'Svi rezultati su prosleđeni.',
    recording_is_starting: ' Snimanje počinje. Molimo sačekajte…',
    please_input_scores_before_submitting:
      'Unesite sve rezultate pre prosleđivanja',
    //EventMenus.jsx
    end_for_all: ' Završite za sve',
    full_screen: 'Ceo ekran',
    breakout_room: 'Soba za odmor',
    //ChimeConference.jsx
    send_invitations: ' Pošaljite pozivnicu (e)',
    add_participants: 'Dodajte učesnika (e)',
    create_breakout_room: 'Kreirajte sobu za odmor',
    //AntMediServeice.jsx
    connecting: 'Povezivanje...',
    //AntPlayer.jsx
    currently_broadcaster_unavailable: 'Emiter trenutno nije dostupan.',
    //BreakoutForm.jsx
    how_many_breakout_room_to_create: 'Koliko soba za odmor da se napravi?',
    create_upto_three_breakout_rooms: '*Kreirajte do 3 sobe za odmor',
    //PassiveUsers/index.js
    allow: 'Dozvolite',
    //PreviewHeader.jsx
    additional: 'Dodatni',
    attachment: 'Prilozi',
    //EventOverview.jsx
    no_description_available: 'Opis nije dostupan.',
    //EventParticipants.jsx
    people: 'LJUDI',
    waiting: 'Čekanje',
    hand_raising_users: 'Korisnici koji podižu ruku -',
    invite: 'pozovite',
    //EventRooms.jsx
    create_room: 'Napravite sobu',
    //Header.jsx
    create_live_event: 'Napravite događaj uživo',
    //Detail.jsx
    support_upto_fivethousand_participants:
      ' Podržava do 5000 učesnika na događaju',
    support_upto_ten_participants:
      ' Podržava do 10 učesnika video zapisa uživo',
    support_upto_twohundred_participants:
      ' Podržava do 200 učesnika na događaju',
    supprt_upto_five_participants: 'Podržava do 5 učesnika video zapisa uživo',
    support_upto_twentyfive_participants:
      'Podržava do 25 učesnika video zapisa uživo na događaju',
    two_live_video_participants:
      '2 učesnika video zapisa uživo za događaj (domaćin i učesnik)',
    you_can_have_upto_five_examinees: 'Možete da imate do 5 ispitanika.',
    you_can_have_upto_twentyfive_participants:
      'Možete da imate do 25 učesnika.',
    you_can_have_upto_five_participants: 'Možete da imate do 5 učesnika.',
    you_can_have_upto_ten_participants: 'Možete da imate do 10 učesnika.',
    select_hosts_email: 'Izaberite e-poštu domaćina',
    //Setting.jsx
    send_invite_email: 'Pošaljite e-poruku sa pozivnicom',
    do_not_send_invite_email: 'Nemojte da šaljete e-poruku sa pozivnicom',
    error: 'Greška',
    //ShowContactsModal.jsx
    max_twentyfive_users_allowed:
      'Dozvoljeno je da izaberete najviše 25 korisnika',
    max_five_users_allowed: 'Dozvoljeno je da izaberete najviše 5 korisnika',
    max_ten_users_allowed: 'Dozvoljeno je da izaberete najviše 10 korisnika',
    no_user_found: 'Nijedan korisnik nije pronađen',
    //SwitchSettings.jsx
    transcribe_to: 'Transkribujte',
    //ZoomForm.js
    integrate_zoom_to_start_meeting:
      'Integrišite zumiranje naloga da biste počeli sa zumiranjem sastanka.',
    zoom_is_not_integrated: 'Zumiranje nije integrisano',
    // Poll.jsx
    delete_poll: 'Izbrišite anketu',
    add_poll: 'Dodajte anketu',
    /* @Added By: Prabin */
    //Events
    live_now: 'UŽIVO SADA !!!',
    average_rating: 'Prosečna ocena',
    review: 'Recenzija',

    // Reports/Course/Details/Details.jsx
    time_spent: 'Utrošeno vreme',
    total: 'Ukupno',
    /* @Added By: Furkan */
    // Reports/Events/Preview/Preview.jsx
    mins: 'Minuta',
    /* @Added By: Furkan */
    // Reports/Lesson/Details/Internal/Quiz/Quiz.jsx
    no_data: 'Nema podataka za ovaj kviz',
    total_score: 'Ukupan rezultat',
    pass_score: 'Rezultat za prolaz',
    point: 'Poeni',
    /* @Added By: Furkan */
    // Reports/Lesson/Details/Internal/Quiz/QuizByUser/QuizByUser.jsx
    wrong: 'Pogrešno',
    response: 'Odgovor',
    submitted: 'Potvrđeno',
    /* @Added By: Furkan */
    // Reports/LiveAssessments/Preview/Preview.jsx
    average: 'Prosečno',
    /* @Added By: Furkan */
    // Reports/Maze/Preview/Preview.jsx
    total_play: 'Ukupna reprodukcija',
    view_graph: 'Prikaži grafikon',
    time_spent_mins: 'Utrošeno vreme (Minuti)',
    play: 'Pokreni',
    ideal_path: 'Idealna putanja',
    user_incorrect_path: 'Pogrešna putanja korisnika',
    ideal_path_taken: 'Idealna putanja koju je odabrao korisnik',
    scenario: 'Scenario',
    option: 'Opcija',
    spend: 'Potrošeno',
    /* @Added By: Furkan */
    // Reports/Report/Report.jsx
    average_spending_time: 'Prosečno potrošeno vreme',
    activity_overview: 'Pregled aktivnosti',
    /* @Added By: Furkan */
    // Reports/Report/Report_.jsx
    live_event: 'Događaji uživo',
    live_assessment: 'Procena uživo',
    report_download: 'Preuzimanje izveštaja',
    all_workshops: 'Sve radionice',
    /* @Added By: Furkan */
    // Reports/User/Detail/Detail.jsx
    overview_average_activity: 'Pregled prosečne aktivnosti',
    overview_workshop_graph: 'Pregled grafika radionice',
    correct_feedback: 'Ispravna povratna informacija',
    incorrect_feedback: 'Neispravna povratna informacija',
    checkin_checkout: 'Prijavljivanje - Odjavljivanje',
    minutes: 'minuti',
    incorrect_path: 'Pogrešna putanja',
    answer_not_available: 'Odgovor nije dostupan',
    views: 'prikazi',
    item: 'Artikal',
    questions: 'Pitanja',
    total_points: 'Ukupno poena',
    total_attempts: 'Ukupno pokušaja',
    /* @Added By: Furkan */
    // Reports/User/Detail/Detail.jsx
    created_date: 'Datum kreiranja',
    host_name: 'Ime domaćina',
    host_section: 'Odeljak “domaćin”',
    /* @Added By: Furkan */
    // views/SkillJourney/SkillJourney.jsx
    choose_products: 'Izaberite proizvode',
    scorms: 'Scorm-ovi',
    /* @Added By: Furkan */
    // views/SkillJourney/View/View.jsx
    skill_journey_overview: 'Pregled obilaska veština',
    /* @Added By: Furkan */
    // components/Header/internal/Informations/Informations.jsx
    how_to_use: 'Kako se koristi',
    live_broadcast_description:
      'INTEGRISALI SMO VIDEO UŽIVO U JEDNOSTAVAN GRADITELJ KURSEVA',
    live_broadcast_subdescription:
      'Sa ShareLook-ovim patentiranim sistemom prenosa uživo, možete stvoriti angažman, automatizovati učenje i maksimalno povećati  deljenje znanja.'
  },
  general: {
    save: 'sačuvajte',
    autosaved: 'Automatski sačuvano',
    back_to: 'Nazad na',
    by: 'Od',
    chat: 'Ćaskanje',
    is_record: 'Zapis', // to translate
    completed: 'Završeno',
    canceled: 'Otkazano',
    component: 'Komponenta',
    confirm: 'Potvrdite',
    course: 'Kursevi',
    skill: 'Put Veština',
    maze: 'MetaLavirint',
    channel: 'Kanal',
    podcast: 'Podcast',

    date: 'Datum',
    details: 'Detalji',
    empty: 'Nema podataka',
    enrolled: 'Upisano',
    free: 'Besplatno',
    graph: 'Grafikon',
    loading: 'Učitavanje...',
    lesson: 'lekcija',
    lessons: 'lekcije',
    live_assessment: 'Procena uživo',
    live_event: 'Događaj uživo',
    maze: 'Lavirint', // to translate ,
    skill: 'Obilazak veština', // to translate
    no: 'Ne',
    of: 'Od',
    or: 'Ili',
    order: 'Poručite / Porudzbina', // to translate
    organization: 'Organizacija',
    page: 'Strana',
    pages: 'Strane',
    personal: 'Lično',
    poll: 'Anketa',
    rating: 'Ocena',
    reset: 'Poništite',
    signin: 'Prijavite se',
    signup: 'Prijavite se',
    soon: 'Uskoro',
    type: 'Tip',
    uploading: 'Otpremanje...',
    yes: 'Da',
    something_went_wrong: 'Nešto je pošlo naopako!',
    view_all: 'Prikaži sve',
    upload_successful: 'Otpremanje uspešno',
    upload_successful_message:
      'Excel dokumenti su uspešno otpremljeni i trenutno se obrađuju. Ovo može potrajati neko vreme.',
    check_email_upload_successful:
      'Molimo <0>proverite svoju e-poštu</0> za <1>izveštaj</1> otpremljene liste korisnika.',
    is_private: 'Privatno',
    to_attach: 'Priložite datoteku', // to translate
    file_attached: 'Priložena datoteka' // to translate
  },

  account: {
    title: 'Nalog',
    subtitle: 'Upravljajte postavkama i informacijama o nalogu.',
    saved: 'Nalog je uspešno promenjen'
  },

  assessments: {
    title: 'Procene',
    subtitle: 'Kreirajte procenu',
    finished: 'Procena je završena',
    countdown: 'Procena uživo će se emitovati u ',
    create: 'Kreirajte procenu',
    list_title: 'Vaše procene',
    delete_warning: 'Želite li zaista da izbrišete ovu stavku?',
    details_title: 'Dodajte detalje procene',
    details_subtitle:
      'Imenujte svoju Procenu i recite publici šta bi trebalo da očekuju da nauče iz nje.',
    disclaimer: `Garantujem da moja snimljena procena neće:
    - kršiti prava bilo kog trećeg lica
  - sadržati bilo kakvu nezakonitost, uključujući klevetnički, nepristojni, razvratni, pornografski, nasilni, uvredljivi, preteći ili diskriminatorni sadržaj, čak i prerušen zvezdicama
  - sadržati bilo kakve lične napade na druge ljude
  - sadržati bilo kakvo imitiranje drugih učesnika, javnih ličnosti ili poznatih ličnosti
  - sadržati bilo kakve snimke ili lične podatke o bilo kom pojedincu bez saglasnosti pojedinca i neće kršiti propise o zaštiti podataka ni u jednom delu sveta
  - sadržati bilo koji komercijalni zahtev ili bilo koji oblik bezvredne pošte`,

    // added_first
    assessment_details: 'Detalji procene', // to translate
    assessment_settings: 'Postavke procene' // to translate
  },

  buildersettings: {
    title: 'Postavke objavljivanja',
    subtitle:
      'Dodavanje postavki događaju, ko može da prikaže događaj i stupi u interakciju sa njim'
  },

  buttons: {
    market_place: 'Tržište',
    back_to_normal: 'Nazad u normalu',
    add: 'Dodati',
    add_page: 'Dodati stranicu',
    add_lesson: 'Dodati lekciju',
    add_answer: 'Dodati novi odgovor',
    add_group: 'Dodati grupu',
    add_organization: 'Dodati organizaciju',
    add_question: 'Dodati pitanje',
    add_quiz: 'Dodati kviz',
    add_users: 'Dodati korisnike',
    back: 'Nazad',
    back_to_maze: 'Nazad na pregled lavirinta', // to translate
    back_to_course: 'Nazad na pregled kursa',
    back_to_lesson: 'Nazad na pregled lekcija',
    back_to_media: 'Nazad na biblioteku medija',
    back_to_details: 'Nazad na detalje',
    cancel: 'Otkažite',
    clear: 'Obrišite',
    close: 'Zatvorite',
    clone: 'Klonirajte',
    close_lesson: 'Zatvorite lekciju',
    clone_course: 'Klonirajte kurs',
    confirm: 'Potvrdite',
    create: 'Kreirajte',
    download: 'Preuzimanje',
    download_mass_user_tamplate: 'Preuzmite šablon',
    add_mass_users: 'Dodajte masovne korisnike',
    upload_excel_list: 'Otpremanje Excel liste',
    delete: 'Izbrišite medije',
    edit: 'Uređivanje',
    edit_course: 'Uredite kurs',
    edit_maze: 'Uredite lavirint', // to translate
    enroll: 'Upišite',
    finish: 'Završite',
    wait: 'Sačekajte...', // to translate
    retry: 'Pokušajte ponovo', // to translate
    upload_image: 'Otpremanje slike',
    upload_image_video: 'Otpremanje slike ili video zapisa',
    select_media_library: 'Izbor iz biblioteke medija',
    make_public: 'Objavite javno',
    make_private: 'Napravite privatno',
    make_org: 'Napravite organizaciju',
    media: 'Biblioteka medija',
    my_theme: 'Moja tema',
    next: 'Sledeće',
    next_lesson: 'Sledeća lekcija',
    next_step: 'Sledeći korak',
    previous_step: 'Prethodni korak',
    publish: 'Objavite',
    publish_assessment: 'Objavite svoju procenu',
    publish_course: 'Objavite svoj kurs',
    publish_scorm_course: 'Objavite svoj SCORM kurs', // to translate
    publish_event: 'Objavite svoj događaj',
    publish_maze: 'Objavite svoj lavirint', // to translate
    reset: 'Poništite',
    reset_elements: 'Poništite elemente',
    save: 'Sačuvajte',
    creating: 'Kreiranje...',
    updating: 'Ažuriranje...',
    saved: 'Sačuvano',
    save_for_later: 'Sačuvajte za kasnije',
    save_settings: 'Sačuvajte postavke',
    select_files: 'Izaberite datoteke',
    select_theme: 'Izaberite temu',
    start_lesson: 'Počnite lekciju',
    update: 'Ažuriranje',
    import: 'Unesite elemente', // to translate
    upload: 'Otpremanje',
    upload_audio: 'Otpremanje zvuka',
    upload_photo: 'Otpremanje profilne fotografije',
    upload_video: 'Otpremanje Video zapisa',
    enrolled: 'Upisan',
    unenroll: 'Ispisan',
    from_library: 'Biblioteka medija',
    remove: 'Uklonite',
    removed: 'Uklonjeno',
    start_broadcast: 'Započnite emitovanje',
    end_broadcast: 'Završite emitovanje',
    camera: 'Kamera',
    screen: 'Ekran',
    screen_with_camera: 'Ekran sa kamerom',
    // added_first
    insert: 'Unesite', // to translate
    inserting: 'Unošenje', // to translate
    upload_pdf: 'Otpremanje PDF', // to translate
    portrait: 'Portret', // to translate
    landscape: 'Pejzaž', // to translate
    import_from_library: 'Unesite tekst iz biblioteke medija', // to translate
    question_answer_ai: 'Pitanje Odgovor Veštačka Inteligencija', // to translate
    //maze
    take_maze: 'UZMI LAVIRINT' // to translate
  },

  card: {
    quick_add: 'Brzo dodavanje',
    add: 'Dodati',
    clone: 'Klonirati',
    completed: 'Završene lekcije'
  },

  course: {
    upcoming_course: 'Predstojeći kurs',
    unPublishEvent: 'Opozovite objavljivanje događaja',
    unPublishAssessment: 'Opozovite objavljivanje procene',
    unPublishMaze: 'Opozovite objavljivanje lavirinta', // to translate
    pastCourse: 'Kurs obuke',
    upcoming: 'Predstojeći događaj uživo',
    upcomingMaze: 'Predstojeći lavirint', // to translate
    pastMaze: 'Prošli lavirint', // to translate
    pastEvent: 'Prpšli događaj uživo',
    pastAssessment: 'Prošla procena uživo',
    upcomingAssessment: 'Predstojeća procena uživo',
    created: 'Datum kreiranja:',
    assignees: 'Zastupnici',
    organisations:
      ' {{ organizacije }} Organizacije, <2> {{ korisnici }} korisnici</2>',
    event_date: 'Datum događaja uživo <1> {{ datum }} </1>',
    delete_warning: 'Da li ste sigurni da želite ovo da izbrišete',
    clonning_no_lesson:
      'Dodajte bar jednu lekciju da biste klonirali ovaj kurs.',
    clone_warning: 'Da li ste sigurni da želite ovo da klonirate',
    clone_success: 'Je u procesu kloniranja ',
    disclaimer: `Garantujem da moj kurs ne:
- krši prava bilo kog trećeg lica
- sadrži bilo kakvu nezakonitost, uključujući klevetnički, nepristojni, razvratni, pornografski, nasilni, uvredljivi, preteći ili diskriminatorni sadržaj, čak i prerušen zvezdicama
- sadrži bilo kakve lične napade na druge ljude
- sadrži bilo kakvo imitiranje drugih učesnika, javnih ličnosti ili poznatih ličnosti
- sadrži bilo kakve snimke ili lične podatke o bilo kom pojedincu bez saglasnosti pojedinca i neće kršiti propise o zaštiti podataka ni u jednom delu sveta
- sadrži bilo koji komercijalni zahtev ili bilo koji oblik "bezvredne pošte"`
  },

  coursecreate: {
    dropzone_text: 'Umetnite medije',
    sidebar_text: 'Izaberite temu <1/> za svoje <3/> lekcije',
    delete_warning: 'Da li ste sigurni da želite da izbrišete ovu lekciju?'
  },

  coursepage: {
    quizview_loading: 'Proveravam odgovore. Molim te sačekaj...',
    quizview_answer: 'Vaš odgovor'
  },

  coursequiz: {
    title: 'Kvizovi u svim lekcijama'
  },

  dashboard: {
    tooltip_title: 'Ne prikazuj ovaj video ponovo',
    page_title: 'Statistika Vaših kurseva',
    page_subtitle: 'Status kurseva koje ste kreirali',
    profile_add_info:
      'Dodajte <1>{{nedovršeniTekst}}</1> da biste dovršili profil.',
    profile_build:
      'Napravite svoj profil <1>ovde</1>, obavestite nas o svojim interesovanjima i veštinama.',
    profile_title: 'Jačina profila',
    more_details: 'Više detalja'
  },

  errors: {
    answer: 'Molimo unesite odgovor',
    answer_correct: 'Odaberite tačan odgovor',
    author: 'Molimo unesite ime autora', // to translate
    category: 'Molimo odaberite kategoriju', //to translate
    course_outline: 'Molimo unesite prikaz strukture kursa', // to translate
    course_obj: 'Molimo unesite ciljeve kursa', // to translate
    course_description: 'Molimo unesite opis kursa', // to translate
    maze_outline: 'Molimo unesite strukturu lavirinta', // to translate
    maze_obj: 'Molimo unesite ciljeve lavirinta', // to translate
    maze_description: 'Molimo unesite opis lavirinta', // to translate
    code: 'Molimo unesite kod',
    criterion: 'Molimo unesite kriterijum',
    duration: 'Trajanje je obavezno',
    element: 'Molimo unesite element',
    email: 'Molimo unesite e-poštu',
    email_invalid: 'Unesena e-pošta nije važeća',
    feedback_correct: 'Molimo ispravno unesite povratne informacije',
    feedback_incorrect: 'Molimo unesite neispravne povratne informacije',
    host: 'Molimo unesite domaćina događaja',
    host_assessment: 'Molimo unesite domaćina procene',
    image: 'Molimo otpremite sliku',
    lessons: 'Molimo unesite broj lekcija', // to translate
    location: 'Molimo unesite vašu lokaciju',
    live_location: 'Molimo odaberite lokaciju za emitovanje',
    limit: 'Molimo unesite minute za protok uživo',
    min_3char: 'Minimum 3 znaka',
    number: 'Unesite pozitivan broj.',
    host_email_require: `e-pošte domaćina su obavezne.`,
    attendee_email_require: `e-pošte učesnika su obavezne.`,
    user_email_require: `e-pošte korisnika su obavezne.`, // to translate
    team_size: `Veličina tima je obavezna.`, //to translate
    name: 'Unesite Vaše ime',
    not_found_course: 'Kurs nije pronađen',
    not_found_event: 'Događaj nije pronađen',
    not_found_assessment: ' Procena nije pronađena',
    organization: 'Molimo odaberite organizaciju', // to translate
    pass_score: 'Unesite oznake između 0 i 100', // to translate
    password: 'Molimo unesite lozinku',
    password_digit: 'Najmanje jedna cifra',
    password_short: 'Lozinka je prekratka, minimum 10 znakova',
    password_special: 'Najmanje jedan specijalni znak',
    password_uppercase: 'Najmanje jedano veliko slovo',
    password_lowercase: 'Najmanje jedano malo slovo',
    phone: 'Molimo unesite telefon',
    phone_invalid: 'Nevažeći telefonski broj',
    position: 'Molimo unesite položaj',
    price: 'Molimo unesite cenu (5 ili više)', // to translate
    question: 'Molimo unesite pitanje',
    start_date: 'Datum i vreme početka su obavezni',
    tag: 'Molimo izaberite oznaku',
    topics: 'Molimo izaberite najmanje jednu temu.',
    live_topics: 'Molimo dodajte teme',
    title: 'Molimo unesite naslov',
    title_assessment: 'Molimo unesite naslov procene',
    title_course: 'Molimo unesite naslov kursa',
    title_maze: 'Molimo unesite naslov lavirinta', // to translate
    title_empty: 'Naslov ne može biti prazan',
    title_event: 'Molimo unesite naslov događaja',
    title_lesson: 'Molimo unesite naslov lekcije',
    title_quiz: 'Molimo unesite naslov kviza',
    trainer_bio: 'Molimo unesite biografiju trenera', // to translate
    trainer_linkedin: 'Molimo unesite linkedin stranicu trenera', // to translate
    username: 'Molimo unesite korisničko ime',
    upload_error: 'Greška - datoteka nije kompatibilna!',
    upload_more_than_10: 'Možete da otpremite samo 10 datoteka odjednom.',
    video: 'Molimo unesite broj video zapisa', // to translate
    video_link: 'Molimo unesite link videa', // to translate
    topics_max: 'Dodajte najviše 5 tema.', // to translate  (just the digit 5)
    upload_excel: 'Uverite se da ste otpremili ispravnu datoteku.',
    title_excel: 'Greška pri otpremanju šablona:',
    file_size_exceed: 'Veličina datoteke premašuje',
    subtitle_excel:
      'Uverite se da ste koristili navedeni šablon i da li su kolone ispravno popunjene.',
    select_broadcast_option: 'Izaberite opciju emitovanja ovog događaja',
    multi_hosts_number_error:
      'Broj prezentatora ne može da premaši više od navedenog za događaj.',
    conference_people_number_error: `Broj učesnika ne može da premaši više od navedenog za događaj.`,
    select_max_host: 'Izaberite najmanje 1 prezentatora za događaj.',
    select_max_conference: 'Izaberite najmanje 1 učesnika za događaj.',
    stream_stop_error: 'Pokušavamo ponovno povezivnje…',
    no_stream_error: 'Čeka se domaćin da započne događaj',
    unsecure_context:
      'Fatalna greška: pretraživač ne može da pristupi kameri i mikrofonu zbog neobezbeđenog konteksta. Instalirajte SSL i pristupite putem https-a',
    ws_not_supported:
      'Fatalna greška: WebSocket nije podržan u ovom pretraživaču',

    // added_first
    no_org: 'Izaberite najmanje 1 organizaciju za nastavak.', // to translate
    no_org_group: 'Izaberite najmanje 1 organizacionu grupu za nastavak.', // to translate
    waiting_to_join: 'Čekamo da se neko priključi!', // to translate

    //new
    select_transcribe_locale: 'Izaberite jezik koji želite da transkribujete', // to translate
    transcribe_limit: 'Molimo unesite minute za transkripciju', // to translate
    not_complete: 'Informacije o tržištu nisu dovršene', // to translate
    complete: 'Informacije o tržištu su dovršene', // to translate
    not_admin:
      'Potrebna administratorska privilegija za objavljivanje na tržištu', // to translate
    no_course: 'Unesite naslov i izaberite sliku da biste omogućili tržište.', // to translate
    scorm_not_complete:
      'Unesite naslov i izaberite sliku za otpremanje skorm datoteke', // to translate
    //maze
    not_found_maze: 'Lavirint nije pronađen', // to translate
    email_require: 'E-pošte su obavezne', // to translate
    poll_required: 'Podaci ankete su obavezni.' // to translate
  },

  events: {
    title: 'Dodajte detalje događaja uživo',
    change_host: 'Promenite domaćina',
    finished: 'Događaj je završen',
    countdown: 'Događaj uživo će se emitovati u ',
    subtitle:
      'Imenujte svoj događaj uživo i recite publici šta bi trebalo da očekuju da nauče iz njega.',
    poll_disabled: 'Anketa nije dostupna u ovom događaju',
    disclaimer: `Garantujem da moj snimljeni događaj neće:
- kršiti prava bilo kog trećeg lica
- sadržati bilo kakvu nezakonitost, uključujući klevetnički, nepristojni, razvratni, pornografski, nasilni, uvredljivi, preteći ili diskriminatorni sadržaj, čak i prerušen zvezdicama
- sadržati bilo kakve lične napade na druge ljude
- sadržati bilo kakvo imitiranje drugih učesnika, javnih ličnosti ili poznatih ličnosti
- sadržati bilo kakve snimke ili lične podatke o bilo kom pojedincu bez saglasnosti pojedinca i neće kršiti propise o zaštiti podataka ni u jednom delu sveta
- sadržati bilo koji komercijalni zahtev ili bilo koji oblik "bezvredne pošte"`,
    prompt_message:
      'Napuštanje ove stranice će završiti vaš događaj. Želite li da napustite ovu stranicu?',
    duration_exceed_message:
      'Vaše vreme emitovanja premašuje, Aplikacija će prestati da emituje program.',
    before_schedule_message:
      'Samo što niste započeli emitovanje pre planiranog vremena događaja. Imajte u vidu da će se zaustavljanjem emitovanja završiti događaj.',
    browser_unsupportive_message:
      'Vaš pretraživač ne podržava deljenje ekrana. Podržane pretraživače možete videti na ovom linku',
    cancel_switch_host_message:
      'Domaćin nije dostupan. Događaj će biti nastavljen sa vašeg kraja.',
    coaching_prompt_message:
      'Ne možete napustiti ovu stranicu dok se događaj ne završi.',
    event_modal_warn: 'Želite li da napustite ovaj događaj?',
    event_end_warn: 'Želite li da završite ovaj događaj?',
    confirm_message: 'Događaj će se završiti ako kliknete na dugme "U redu".',
    screen_share_denied: 'Odbili ste da delite svoj ekran',
    media_not_found:
      'Kamera ili mikrofon nisu pronađeni ili nisu dozvoljeni na uređaju.',
    media_not_access:
      'Kamera ili Mikrofon koristi neki drugi proces koji ne dozvoljava čitanje uređaja',
    constraint_error:
      'Nije pronađen uređaj koji odgovara vašim video i audio ograničenjima. Možete da promenite ograničenja video zapisa i zvuka',
    media_access_denied: 'Nije vam dozvoljeno da pristupite kameri i mikrofonu.'
  },

  filters: {
    days7: 'Poslednjih 7 dana',
    days15: 'Poslednjih 15 dana',
    days30: 'Poslednjih 30 dana',
    days365: 'Poslednjih 365 dana',
    date: 'Datum kreiranja',
    relevance: 'Važnost',
    popularity: 'Popularnost',
    name: 'Ime',
    group: 'Grupa',
    Newest_to_Oldest: 'Od novijeg do starijeg',
    Oldest_to_Newest: 'Od starijeg do novijeg',
    A_Z: 'Od A do Š',
    Z_A: 'Od Š do A'
  },

  helpers: {
    password:
      'Da bismo osigurali bezbednost vašeg naloga, potrebno nam je najmanje jedno malo slovo, broj u vašoj lozinki. Takođe je potrebno da imate minimalnu dužinu od 10 znakova.',
    phone: 'Unesite i pozivni broj zemlje, na primer: +65',
    username:
      'Vaše korisničko ime se po potrebi tretira kao javno informisanje i deli sa drugim korisnicima. Kao takvi, preporučujemo da ne koristite lične informacije u korisničkom imenu',
    public_description_normal:
      ' Vaš <0><0/></0> je sačuvan i podrazumevano se smatra privatnim. To znači da samo vi možete da vidite ovaj sadržaj. Da biste objavili ovaj sadržaj, možete izabrati jednu od dole navedenih opcija. Objavljivanje <0><0/></0> za Javnost znači da će biti dostupan svim korisnicima u platformi. Opcija "Određeni korisnici" će vam omogućiti da delite svoj <0><0/></0> sa određenim korisnicima koristeći e-adresu povezanu sa njihovim Sharelook nalogom.',
    public_description_admin:
      'Ovaj <0><0/></0> je sačuvan i podrazumevano se smatra privatnim. To znači da samo vi (i kreator sadržaja) možete da vidite ovaj sadržaj . Da biste objavili ovaj sadržaj, možete izabrati jednu od dole navedenih opcija. Objavljivanje <0><0/></0> za javnost znači da će biti dostupan svim korisnicima u platformi - uključujući i one van vaše organizacije. Objavljivanje u organizaciji znači da će svi korisnici unutar organizacije moći da je vide. Takođe možete da je objavite u 1 ili više grupa, što znači da će samo korisnici unutar tih grupa moći da je vide. Na kraju, imate mogućnost da je objavite određenim korisnicima unutar i izvan vaše organizacije koristeći e-adresu sharelook naloga.'
  },

  labels: {
    add: 'Dodajte',
    no_of_people_in_conference: 'Koliko je ljudi na konferenciji?', //to translate
    portrait: 'Obsecite portret',
    landscape: 'Obsecite pejzaž',
    transcribe_settings: 'Postavke transkribovanja', // to translate
    transcribe: 'Transkribujte', // to translate
    answer_type: 'Tip odgovora',
    answers: 'Odgovori',
    back_to_quiz: 'Back to Quiz list',
    back_to_question: 'Nazad na spisak pitanja',
    chat: 'Ćaskanje',
    chat_available: 'Ćaskanje nije dostupno u ovom događaju',
    chat_report: 'Izveštaj ćaskanja',
    choice_single: 'Jedan izbor',
    choice_multiple: 'Više izbora',
    choice_free: '"Slobodan" izbor',
    choice_sorting: '"Sortiranje" - izbor',
    choice_matrix: '"Matriks Sortiranje" - izbor',
    clone_lesson_permission: 'Dozvola kloniranja',
    code: 'Kod',
    correct: 'Ispravno',
    created: 'Datum kreiranja',
    clone_modal: 'Klonirajte kurs',
    cloning_course: 'Kloniranje kursa...',
    cloning_maze: 'Kloniranje lavirinta...', //to translate
    cloning: 'Kloniranje...',
    cloning_course_desc:
      'Ovaj proces će malo potrajati. Molimo Vas budite strpljivi.',
    cloning_success: 'Kurs "<0/>" je uspešno kloniran!',
    maze_cloning_success: 'Lavirint "<0/>" je uspešno kloniran!', // to translate
    create_certificate: 'Kreirajte sertifikat', // to translate
    create_badge: 'Kreirajte bedz', // to translate
    certificate_added: 'Sertifikat je dodat.', // to translate
    badge_added: 'Bedz je dodat.', // to translate
    certificate_warning:
      'Ne možete da uređujete certifikat/značku kada se objavi!', // to translate
    description: 'Opis',
    disclaimer: 'Odricanje odgovornosti',
    drop_file: 'Spustite datoteku ovde...',
    duration: 'Trajanje',
    edit: 'Uređivanje',
    email: 'E-pošta',
    event: 'Događaj',
    event_all: 'Svi njegovi događaji',
    event_date: 'Lokalni datum/vreme događaja uživo',
    event_this: 'Ovaj događaj',
    expire: 'Ističe',
    expiry_date: 'Rok trajanja',
    forgot: 'Zaboravili ste lozinku?',
    group: 'Grupa',
    groups_list: 'Spisak grupa',
    host: 'Domaćin',
    id_annotation: 'ID napomene',
    id_number: 'ID broj', // to translate
    id_quiz: 'ID kviza',
    incorrect: 'Neispravno',
    interests: 'Interesi',
    invited: 'Pozvani',
    live_chat: 'Diskusija uživo',
    live_stream_limit: 'Minuti protoka uživo',
    contact_text:
      'Da biste promenili mesečno ograničenje protoka uživo, kontaktirajte',
    contact_admin:
      '<0> Ako želite da promenite mesečno ograničenje protoka uživo, molimo vas da kontaktirate </0> <1>admin@sharelook.com</1>',
    limit_stream_text:
      'Preostali minuti uživo: <0>{{ limit }}</0> minuta <1/><2/> <3>Da biste promenili mesečno ograničenje protoka uživo molimo vas da kontaktirate</3> <4>admin@sharelook.com</4>',
    location: 'Lokacija',
    lessons: 'Lekcije',
    location_broadcast: 'Lokacija servera domaćina',
    location_broadcast_subtitle:
      'Dodavanje lokacije koja je najbliža lokaciji domaćina emitovanja da bi se smanjilo audiovizuelno kašnjenje',
    media_manager: 'Menadžer media',
    minutes: 'Minuti',
    name: 'Ime',
    online_quiz: 'Online kviz',
    organiser: 'Autor',
    organization: 'Organizacija',
    overall_emotion: 'Sveukupno iskustvo:',
    organizations_list: 'Spisak organizacija',
    password: 'Lozinka',
    participants: 'Učesnici',
    pass_score: 'Najmanji broj poena za prolaz', // to translate
    picture: 'Slika',
    scorm_zip: 'Scorm Zip', // to translate
    phone: 'Telefon',
    photo: 'Fotografija',
    poll: 'Anketa',
    position: 'Položaj',
    processing: 'Obrada',
    privacy_settings: 'Postavke privatnosti',
    question: 'Pitanje',
    quiz_create: 'Kreirajte kviz',
    quiz_name: 'Naziv kviza',
    quiz_update: 'Ažurirajte kviz',
    select_organization: 'Izbor organizacije',
    settings: 'Postavke',
    show: 'Prikaži',
    show_graph: 'Prikaži rezultat grafikona',
    signin: 'Prijavi se',
    signup: 'Prijavi se',
    sort_by: 'Sortiraj po',
    start_date: 'Datum početka',
    tags: 'Oznake',
    terms: 'Pristajem na ove <1>uslove</1>.',
    timezone: 'Vremenska zona', //to translate
    title: 'Naslov',
    topics: 'Teme',
    topic: 'Tema',
    total_comments: 'Ukupni komentari',
    username: 'Korisničko ime',
    users_list: 'Spisak korisnika',
    users_emails: `Odaberite e-poštu određenog korisnika`,
    description_specifiction_email:
      'Unesite 1 e-adresu po redu da biste ovo podelili sa više određenih korisnika.',
    message_specific_email: 'Unesite e-poruku određenog korisnika.',
    viewers: 'Gledaoci',
    edit_course: 'Uređivanje',
    edit_assessment: 'Uređivanje',
    edit_event: 'Uređivanje',
    edit_maze: 'Uređivanje', //to translate
    delete_course: 'Izbrišite',
    delete_event: 'Izbrišite',
    delete_maze: 'Izbrišite', //to translate
    delete_assessment: 'Izbrišite',
    view_course: 'Prikaz',
    view_event: 'Prikaz',
    view_assessment: 'Prikaz',
    view_maze: 'Prikaz', //to translate
    date_event: 'Datum događaja uživo',
    date_assessment: 'Datum procene uživo',
    clone_of: 'Klon',
    clone_course:
      'Napravite klona ovog kursa koji možete modifikovati nezavisno od originala, uključuje sve lekcije i stranice.',
    make: 'Napraviti',
    available_to: 'dostupno bilo kom ShareLook korisniku',
    uploaded_by: 'Otpremljeno od strane: ',
    course: 'Kurs',
    assessment: 'Procena',
    user_not_exist: 'Korisnik ne postoji, želite li da pošaljete pozivnicu?',
    check_user: 'Primetiti',
    user_not_exist_in_org:
      'Korisnik ne postoji u ovoj organizaciji, želite li da pošaljete pozivnicu?',
    title_modal_stream: 'Promenite ograničenje emitovanja za organizacije',
    des_warning_stream: 'Uskoro će te promeniti',
    monthly_stream: 'mesečno ograničenje emitovanja uživo:',
    min_per_month: 'minuti/meseci',
    broadcast_label: 'Želim da uradim:',
    hosts_emails: `Unesite e-poštu određenog domaćina`,
    attendee_emails: `Unesite e-poštu određenog učesnika`,
    examinee_emails: `Unesite e-poštu određenog ispitanika`, // to translate
    description_host_specifiction_email: 'Unesite 1 e-poštu po redu.',
    presenter_label: 'Prezentator',
    presenter_label_conference: 'Broj ljudi',
    event_privacy: 'Režim konferencije',
    // added_second
    alert: 'Uzbuna!', // to translate
    warning: 'Upozorenje!', // to translate
    ok: 'U redu', // to translate
    cancel: 'Otkažite', // to translate
    done: 'Gotovo', // to translate
    insert: 'Umetnite', // to translate
    private: 'Privatno', // to translate
    public: 'Javno', // to translate
    no_connection: 'Internet veza je izgubljena', // to translate
    switch: 'Prebacite', // to translate
    share_screen: 'Deljenje ekrana', // to translate
    stop_share_screen: 'Zaustavite deljenje ekrana', // to translate
    share_screen_with_camera: 'Deljenje ekrana sa kamerom', // to translate
    stop_share_screen_with_camera: 'Zaustavi deljenje ekrana sa kamerom', // to translate
    camera_on: 'Kamera uključena', // to translate
    camera_off: 'Kamera isključena', // to translate
    mic_on: 'sa zvukom', // to translate
    mic_off: 'bez zvuka', // to translate
    fullscreen: 'ceo ekran', // to translate
    live_now: 'Uživo Sada', // to translate
    schedule_on: 'Zakažite za', // to translate
    organisations: 'Organizacioje', // to translate
    org_groups: 'Organizacione Grupe', // to translate
    specific_user: 'Određeni korisnik', // to translate
    gif: 'GIF', // to translate
    unavailable: 'nedostupno', // to translate
    yes: 'Da', // to translate
    no: 'Ne', // to translate
    event_duration_message: 'Maksimum 300 minuta(5h)', // to translate
    send_email: 'Pošaljite obaveštenje e-poštom', // to translate
    admin_only: 'Samo admin', // to translate
    join: 'Pridruži se', // to translate
    leave: 'Napusti', // to translate
    share: 'Podeli', // to translate
    share_text: 'Upišite e-poštu sa kim želite da odelite ovu datoteku', // to translate
    share_text_title: 'Podelite PDF', // to translate
    share_text_title_txt: 'Podelite Tekst', // to translate
    select_users: 'Odaberite korisnike', // to translate
    delete: 'Obrišite', // to translate
    attachment_event: 'Prilozi za događaj: ', // to translate,
    // newly added
    transcribe_limit: 'Transkribuj miute', // to translate
    monthly_transcribe: 'ograničenje mesečne transkribopcije:', // to translate
    enable_ai: 'Omogući Veštačku Inteligenciju:', // to translate
    media_service: 'Medijska usluga', // to translate
    allow_others: 'Dozvoli drugima da uređuju' // to translate
  },

  broadcastOptions: {
    stream_from_phone: 'Direktan prenos pomoću telefona',
    other_webrtc: 'Webinar sa računara',
    multihost: 'Multicast webinar sa računara',
    peer2peer: 'Trenerska sesija',
    conference: 'Konferencija uživo'
  },

  //to translate
  conferenceTeamOptions: {
    uptoTen: '1 do 10', // to translate
    uptoTwenty: '11 do 20', // to translate
    uptoTwentyFive: '21 do 25' // to translate
    // uptoForty: '31 do 40'
  },

  //to translate
  conferenceAttendeeOptions: {
    uptoTwoHundredFifty: '1 do 250' // to translate
    // uptoHundred: '51 do 100',
    // uptoTwoHundred: '101 do 200'
    // uptoForty: '31 do 40'
  },

  mediaServices: {
    ANTMEDIA: 'ANTMEDIA', // to translate
    CHIME: 'CHIME' // to translate
  },

  lessoncreate: {
    title: 'Dodajte detalje lekcije',
    subtitle:
      'Imenujte svoju lekciju i recite publici šta bi trebalo da očekuju da nauče iz nje.',
    input_label_title: 'Naslov lekcije',
    input_label_topics: 'Tema lekcije',
    input_label_description: 'Opis lekcije',
    delete_warning: 'Želite li zaista da izbrišete ovu stranicu?'
  },

  lessonoverview: {
    title: 'Dodajte lekciju',
    subtitle: 'Dodajte postojeću lekciju ili kreirajte novu',
    new_lesson: 'kreirajte novu lekciju',
    new_lesson_sub: 'Kreirajte potpuno novu lekciju od nule!',
    existing_lesson: 'Izaberite postojeću lekciju',
    existing_lesson_sub:
      'Link ka postojećoj lekciji, promene napravljene u ovoj lekciji uticaće i na ovu lekciju na drugim kursevima.',
    clone_lesson: 'duplirajte postojeću lekciju',
    clone_lesson_sub:
      'Napravite jedinstvenu kopiju lekcije na ovom kursu, promene napravljene u ovoj lekciji neće uticati na originalnu lekciju.',
    clone_lesson_modal_sub:
      'Kliknite na dugme klon ispod lekcije koju želite da dodate svom kursu.'
  },

  management: {
    groups_title: 'Upravljanje grupama',
    delete_warning: 'Da li ste sigurni?',
    organizations_title: 'Moje organizacije',
    organizations_subtitle: 'Dodajte organizaciju na listu',
    users_title: 'Upravljanje korisnicima',
    users_position: 'Viši menadžer naloga',
    user_not_found: 'Korisnik nije pronađen',
    select_org:
      'Pronađite i odaberite organizaciju koja će upravljati korisnicima',
    select_org_report:
      'Pronađite i odaberite organizaciju za generisanje izveštaja' // to translate
  },

  audio: {
    modal_title: 'Unesite zvuk',
    list_view: 'Prikaz liste',
    create_audio_modal_title: 'Kreirajte zvuk',
    edit_audio_modal_title: 'Uređivanje zvuka',
    public_audio_not_found: 'Zvuk nije pronađen.',
    private_audio_not_found: 'Još uvek niste otpremili nikakav zvuk',
    org_audio_not_found: 'Zvuk nije pronađen.', // to translate
    are_you_sure_to_delete: 'Da li stvarno želite da izbrišete?',
    type_something: 'Otkucaj nešto',
    select_voice: 'Izaberite',
    file_name: 'Naziv datoteke',
    description: 'Opis',
    topic: 'Tema',
    key_words_tag: 'Ključne reči Oznaka',
    mp3_audio: 'MP3 zvuk',
    created: 'Kreirano',
    duration: 'Trajanje',
    close: 'zatvorite'
  },

  image: {
    modal_title: 'Umetnite sliku',
    image: 'Slika',
    pixel: 'Piksel',
    dimension: 'Dimenzija',
    public_image_not_found: 'Slika nije pronađena.',
    private_image_not_found: 'Još uvek niste otpremili sliku',
    org_image_not_found: 'Slika nije pronađena.' // to translate
  },

  annotation: {
    modal_title: 'Napomena'
  },

  text: {
    modal_title: 'Uređivač teksta',
    insert_text: 'Unesite tekst', // to translate
    insert_question_answer: 'Pitanje Odgovor Veštačka Inteligencija', //to translate
    modal_title2: 'Tekstualna galerija', // to translate
    my_text_library: 'Moja biblioteka teksta', // to translate
    ai: 'Veštačka Inteligencija', // to translate
    public_text_library: 'Javna biblioteka', // to translate
    organization_text_library: 'Biblioteka Organizacije', // to translate
    no_transcribed_text: 'Nema transkribovanih tekstova', // to translate
    public_text_not_found: 'Javni transkribovani tekst nije pronađen.', // to translate
    org_text_not_found: 'Transkribovan tekst organizacije nije pronađen.' // to translate
  },

  video: {
    modal_title: 'Umetnite video',
    image: 'Video',
    mp4_video: 'MP4 Video',
    public_video_not_found: 'Video nije pronađen.',
    private_video_not_found: 'Još niste otpremili nijedan video',
    org_video_not_found: 'Video nije pronađen.' // to translate
  },

  media: {
    title: 'Biblioteka medija',
    subtitle: 'Biblioteka datoteka',
    modal_title: 'Otpremanje medija',
    canva: 'Uradi to iz Canve', // to translate
    canva_open: 'Kliknite ovde da biste otvorili alatku "Canva Editor"', //to translate
    delete_warning: 'Potvrda brisanja',
    delete_message:
      'Izbrisani mediji će se i dalje pojavljivati na stranicama na kojima su korišćeni',
    dropzone_text: 'ili prevuci i otpusti',
    delete_success: 'Medij je uspešno izbrisan',
    upload_file: 'Otpremite datoteku',
    drag_drop: 'ili prevuci i otpusti',
    import_file: 'Unesite datoteku/e sa računara',
    no_media: 'Još uvek niste otpremili nijedan medij',
    media_type: 'Tip medija',
    video: 'Video',
    image: 'Slika',
    audio: 'Audio',
    gif: 'GIF',
    pdf: 'PDF', // to translate
    transcribed_text: 'Transkribovan tekst',
    txt: 'TEKST', // to translate
    media_not_found: 'Medij nije pronađen.',
    of: 'od',
    disclaimer: `Garantujem da moj medij neće:
- kršiti prava bilo kog trećeg lica
- sadržati bilo kakvu nezakonitost, uključujući klevetnički, nepristojni, razvratni, pornografski, nasilni, uvredljivi, preteći ili diskriminatorni sadržaj, čak i prerušen zvezdicama
- sadržati bilo kakve lične napade na druge ljude
- sadržati bilo kakvo imitiranje drugih učesnika, javnih ličnosti ili poznatih ličnosti
- sadržati bilo kakve snimke ili lične podatke o bilo kom pojedincu bez saglasnosti pojedinca i neće kršiti propise o zaštiti podataka ni u jednom delu sveta
- sadržati bilo koji komercijalni zahtev ili bilo koji oblik "bezvredne pošte”`,

    // added_first
    my_media: 'Moj medij', // to translate
    maze_scenes: 'Scene lavirinta', // to translate
    public_library: 'Javna biblioteka', // to translate
    organization_library: 'Biblioteka Organizacije', // to translate
    upload_from_computer: 'Otpremite sa računara', // to translate
    pexel_images: 'Peksel slika', // to translate
    create: 'Kreirajte', // to translate
    all: 'Sve', // to translate
    male: 'Muškarac', // to translate
    female: 'Žena', // to translate
    processing_audio: 'Obrada zvuka', // to translate
    create_annotation: 'Kreirajte napomenu', // to translate
    popup_over_lesson_text:
      'Napomena će iskočiti preko stranice sa lekcijama nakon klika', // to translate
    edit_detail: 'Uredi detalje', // to translate
    delete: 'Izbrišite', // to translate
    go_create_audio: 'Idi kreiraj zvuk', // to translate
    show_more_details: 'prikaži više detalja', // to translate
    show_less_details: 'prikaži manje detalja', // to translate
    drop_files: 'Otpustite datoteke, gde da ih otpremite', // to translate
    or: 'Ili', // to translate
    import_files: 'Unesite datoteke sa računara', // to translate
    // added_fourth
    human: 'Premium', // to translate
    shared_file: 'Vaša datoteka je uspešno podeljena', // to translate
    error_shared_file: 'Postoji problem u deljenju datoteke, pokušajte ponovo', // to translate
    publish: 'Objavite' // to translate
  },

  navigation: {
    account: 'Nalog',
    assessments: 'Procene',
    dashboard: 'Kontrolna tabla',
    groups: 'Upravljanje grupama',
    logout: 'Odjavite se',
    organisations: 'Organizacije',
    organizations_users: 'Organizacije i Korisnici',
    reports: 'Izveštaji',
    schedule: 'Raspored',
    training: 'Trening',
    users: 'Korisnici',

    // added_first
    nowLive: 'Uživo',

    workshop: 'Moja radionica'
  },

  onboarding: {
    step1_title: 'Korak 1: Recite nam nešto o sebi',
    step1_subtitle: 'Kako se zovete? Odakle ste? Koje je Vaše radno mesto?',
    step2_title:
      'Korak 2: Izaberite neku veštinu koju biste mogli da usavršite',
    step2_subtitle:
      'Dalje nam recite šta biste voleli da razumete bolje. Možda nešto što još ne znate? Novo polje studiranja? Šta vaša voljena osoba radi?'
  },

  pagebuilder: {
    title: 'Kreirajte lekciju',
    subtitle:
      'Vreme je da kreirate sadržaj koji će gledaoci učiti od vas, možete da unesete slikate, video zapise i infografiku',
    select_layout: 'Izbor rasporeda na stranici',
    template1: 'Prazno',
    template2: 'Naslov i Titl',
    template3: 'Naslov i Tekst',
    template4: 'Naslov, Mediji i Tekst',
    template5: 'Naslov i Mediji',
    template6: 'Naslov i Kviz'
  },

  pageconstructor: {
    title: 'Kreiraj i kloniraj lekciju',
    subtitle:
      'Vreme je da kreirate sadržaj koji će gledaoci učiti od vas, možete da dodate slike, video zapise i infografiku'
  },

  passwordreset: {
    success_coded:
      'Poslali smo Vam na e-poštu kod za potvrdu, molimo vas da kopirate kod u polje ispod da biste postavili novu lozinku.',
    success_changed:
      'Uspešno ste postavili novu lozinku. Sada možete da se prijavite.'
  },

  placeholders: {
    attempts_count: 'Broj pokušaja, korisnik može ponovo da pokuša', // to translate
    no_of_people_placeholder: 'Broj ljudi', //to translate
    search: 'Pretraga',
    answer: 'Odgovor',
    chat: 'Recite nešto...',
    code: 'Kod',
    criterion: 'Kriterijum',
    date_event: 'Izaberite datum i vreme',
    date_start: 'Datum početka',
    date_expire: 'Datum isteka',
    description: 'Opis',
    elements: 'Sortiranje elemenata',
    email: 'E-pošta',
    feedback_correct: 'Ispravne povratne informacije',
    feedback_incorrect: 'Neispravne povratne informacije',
    host: 'Domaćin',
    keywords: 'Pretražite ključne reči',
    lesson_description: 'Opis lekcije',
    location: 'Lokacija',
    minutes: 'Minuti',
    name: 'Ime',
    organiser: 'Autor',
    organization: 'Organizacija',
    password: 'Lozinka',
    phone: 'Telefon',
    photo: 'Fotografija',
    picture: 'Slika',
    point: 'Poeni',
    position: 'Položaj',
    question: 'Pitanje',
    quiz: 'Naziv kviza',
    search_course: 'Pretražite po kursu',
    search_media: 'Pretražite medij',
    search_name: 'Pretražite po imenu',
    search_title: 'Pretražite po naslovu',
    search_training: 'Pretražite obuke',
    settings: 'Postavke',
    tags: 'Oznake',
    title: 'Naslov',
    topics: 'Teme',
    username: 'Korisničko ime',
    keyword: 'Ključne reči',
    max_500_characters: 'Najviše 500 znakova',
    no_description: 'Ova datoteka nema opis',
    no_keyword: 'Ova datoteka nema ključne reči',
    no_topics: 'Ova datoteka nema skup tema',
    feedback: 'Poruka',
    contact: 'Kako možemo da pomognemo?',
    text: 'Unesite tekst ovde...' //to translate
  },

  publishsettings: {
    title: 'Postavke objavljivanja',
    event_subtitle:
      'Dodavanje postavki događaju, ko može da gleda događaj i stupi u interakciju sa njim',
    assessment_subtitile:
      'Imenujte svoju Procenu i recite publici šta treba da očekuju da nauče iz nje',
    course_subtitle:
      'Dodavajte postavke kursu, ko može da gleda kurs i stupi u interakciju sa njim',
    disclaimer:
      'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nullam venenatis tellus ex, eu auctor diam tristique et. Fusce vel egestas felis, vel malesuada justo. Suspendisse erat orci, dapibus a nisi quis, ultricies mattis arcu. Proin in suscipit metus. Sed mi tellus, porta in porta eu, accumsan a purus. Donec quis turpis vestibulum, consequat urna ut, vestibulum ex. Sed vulputate ornare auctor. Proin gravida luctus justo at interdum. Proin porttitor, turpis et tincidunt lobortis, dui tortor viverra risus, quis venenatis Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nullam venenatis tellus ex, eu auctor diam tristique et. Fusce vel egestas felis, vel malesuada justo. Suspendisse erat orci, dapibus a nisi quis, ultricies mattis arcu. Proin in suscipit metus. Sed mi tellus, porta in porta eu, accumsan a purus. Donec quis turpis vestibulum, consequat urna ut, vestibulum ex. Sed vulputate ornare auctor. Proin gravida luctus justo at interdum. Proin porttitor, turpis et tincidunt lobortis, dui tortor viverra risus, quis venenatis Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nullam venenatis tellus ex, eu auctor diam tristique et. Fusce vel egestas felis, vel malesuada justo. Suspendisse erat orci, dapibus a nisi quis, ultricies mattis arcu. Proin in suscipit metus. Sed mi tellus, porta in porta eu, accumsan a purus. Donec quis turpis vestibulum, consequat urna ut, vestibulum ex. Sed vulputate ornare auctor. Proin gravida luctus justo at interdum. Proin porttitor, turpis et tincidunt lobortis, dui tortor viverra risus, quis venenatis Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nullam venenatis tellus ex, eu auctor diam tristique et. Fusce vel egestas felis, vel malesuada justo. Suspendisse erat orci, dapibus a nisi quis, ultricies mattis arcu. Proin in suscipit metus. Sed mi tellus, porta in porta eu, accumsan a purus. Donec quis turpis vestibulum, consequat urna ut, vestibulum ex. Sed vulputate ornare auctor. Proin gravida luctus justo at interdum. Proin porttitor, turpis et tincidunt lobortis, dui tortor viverra risus, quis venenatis Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nullam venenatis tellus ex, eu auctor diam tristique et. Fusce vel egestas felis, vel malesuada justo. Suspendisse erat orci, dapibus a nisi quis, ultricies mattis arcu. Proin in suscipit metus. Sed mi tellus, porta in porta eu, accumsan a purus. Donec quis turpis vestibulum, consequat urna ut, vestibulum ex. Sed vulputate ornare auctor. Proin gravida luctus justo at interdum. Proin porttitor, turpis et tincidunt lobortis, dui tortor viverra risus, quis venenatis Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nullam venenatis tellus ex, eu auctor diam tristique et. Fusce vel egestas felis, vel malesuada justo. Suspendisse erat orci, dapibus a nisi quis, ultricies mattis arcu. Proin in suscipit metus. Sed mi tellus, porta in porta eu, accumsan a purus. Donec quis turpis vestibulum, consequat urna ut, vestibulum ex. Sed vulputate ornare auctor. Proin gravida luctus justo at interdum. Proin porttitor, turpis et tincidunt lobortis, dui tortor viverra risus, quis venenatis',
    dates_validation_error: 'Oba datuma bi trebalo da budu popunjena.',
    course_dates_validation_error: 'Унесите датум почетка и истека овог курса.',
    emails_validation_error: 'Lista e-pošte je nevažeća.',
    specific_email_validation_error: 'Dozvoljena je samo jedna e-pošta.',
    i_agree_to_these: 'Slažem se sa ovim ',
    terms_and_conditions: 'uslovima i odredbama.',
    PublicDescription:
      'Besplatni nezavisni korisnici: (privatne i javne opcije)Vaš [Kurs| Događaj| Procena] je sačuvan i podrazumevano se smatra privatnim. To znači da samo vi možete da vidite ovaj sadržaj. Da biste objavili ovaj sadržaj, možete da izaberete da bude javno objavljen ispod. To znači da će kurs biti dostupan svim korisnicima u platformi.',
    OrganisationsDescription:
      'Korisnici organizacije: (Umesto "Završi", koristite "Objavi" i postavite ih na stranicu za objavljivanje isto kao i drugi korisnici, ali bez ikakvih opcija objavljivanja.) Tvoj [Kurs| Događaj| Procena] je sačuvan i privatan je. To znači da samo vi i administratori u vašoj organizaciji to možete da vidite. Kao korisnik, ne možete sami da objavite sadržaj unutar svoje organizacije jer to zahteva administratorska prava. Obratite se jednom od administratora i zamolite ih da objave vaš sadržaj javno, celoj organizaciji, određenim grupama unutar vaše organizacije ili određenim korisnicima.',
    OrganisationGroupsDescription:
      'Admini organizacije: (Za sadržaj napravljen u okviru organizacije: privatni, javni, organizacioni, grupni, određeni korisnici):Ovaj [Kurs| Događaj| Procena] je sačuvan i podrazumevano se smatra privatnoim. To znači da samo vi (i kreator sadržaja) možete da vidite ovaj sadržaj . Da biste objavili ovaj sadržaj, možete izabrati jednu od dole navedenih opcija. Objavljivanje kursa za javnost znači da će biti dostupan svim korisnicima u platformi - uključujući i one van vaše organizacije. Objavljivanje u organizaciji znači da će svi korisnici unutar organizacije moći da je vide. Takođe možete da  objavite u 1 ili više grupa, što znači da će samo korisnici unutar tih grupa moći da vide. Na kraju, imate mogućnost da objavite određenim korisnicima unutar i izvan vaše organizacije koristeći e-adresu sharelook naloga..',
    SpecificUsersDescription:
      'Plaćeni nezavisni korisnici: (privatni, javni i specifični korisnici)Vaš [Kurs| Događaj| Procena] je sačuvan i podrazumevano se smatra privatnim. To znači da samo vi možete da vidite ovaj sadržaj. Da biste objavili ovaj sadržaj, možete izabrati jednu od dole navedenih opcija. Objavljivanje kursa za javnost znači da će biti dostupan svim korisnicima u platformi. Opcija "Određeni korisnici" će vam omogućiti da delite kurs sa određenim korisnicima koristeći e-adresu povezanu sa njihovim Sharelook nalogom.'
  },

  quiz: {
    quiz_empty: 'Još uvek niste napravili kviz',
    questions_empty: 'Još uvek niste kreirali pitanje'
  },

  regions: {
    asia_pacific_australia: 'Australija',
    asia_pacific_india: 'Indija',
    asia_pacific_japan: 'Japan',
    asia_pacific_s_korea: 'Južna Koreja',
    asia_pacific_singapore: 'Singapur',
    asia_pacific_taiwan: 'Tajvan',
    eu_belgium: 'Belgija',
    eu_germany: 'Nemačka',
    eu_ireland: 'Irska',
    south_america_brazil: 'Brazil',
    us_central_iowa: 'Ajova',
    us_east_s_carolina: 'Južna Karolina',
    us_east_virginia: 'Virdžinija',
    us_west_california: 'Kalifornija',
    us_west_oregon: 'Oregon'
  },

  publishmaze: {
    title: 'Postavke objavljivanja', // to translate
    maze_subtitle:
      'Dodajte podešavanja u svoj lavirint, ko može da vidi i komunicira sa vašim lavirintom', // to translate
    disclaimer: `Garantujem da moj lavirint neće:
- kršiti prava bilo kog trećeg lica
- sadržati bilo kakvu nezakonitost, uključujući klevetnički, nepristojni, razvratni, pornografski, nasilni, uvredljivi, preteći ili diskriminatorni sadržaj, čak i prerušen zvezdicama
- sadržati bilo kakve lične napade na druge ljude
- sadržati bilo kakvo imitiranje drugih učesnika, javnih ličnosti ili poznatih ličnosti
- sadržati bilo kakve snimke ili lične podatke o bilo kom pojedincu bez saglasnosti pojedinca i neće kršiti propise o zaštiti podataka ni u jednom delu sveta
- sadržati bilo koji komercijalni zahtev ili bilo koji oblik "bezvredne pošte"` // to translate
  },

  reports: {
    title: 'Izveštaji',

    // added_first
    workshop_report: 'Izveštaj radionice',
    user_report: 'Izveštaj korisnika',
    organization_workshop: 'Radionica Organizacije',
    course: 'Kurs',
    live_event: 'Događaj uživo',
    workShop_graph: 'Grafikon radionice',
    organization_account: 'Nalog Organizacije',
    all: 'Sve',
    name: 'Ime',
    group: 'Grupa', //to translate
    group_name: 'Ime grupe', //to translate
    select_group: 'Izaberite grupu', //to translate
    id_number: 'ID Broj',
    email: 'E-pošta',
    search_user_report: 'Pretraži korisnički izveštaj',
    participant: 'Učesnik',
    participants: 'Učesnici',
    host: 'Domaćin',
    hosts: 'Domaćini', //to translate
    username: 'Korisničko ime',
    event: 'Događaj',
    quiz: 'Kviz',
    assessment: 'Procena',
    time: 'Vreme',
    no_recent_activity: 'Nema nedavnih aktivnosti',
    workshops: 'Radionice',
    courses: 'Kursevi',
    live_events: 'Događaji uživo',
    live_assessments: 'Procene uživo',
    quizzes: 'Kvizovi',
    overview: 'Pregled',
    by: 'Od',
    views: 'Pregledi',
    status: 'Status',
    pass_score: 'Rezultat za prolaz', // to translate
    poll: 'Anketa',
    comment: 'Komentar',
    comments: 'Komentari',
    no_comments: 'Nema komentara',
    no_polls: 'Nema Anketa',
    live_date: 'Datum lajva',
    score: 'Rezultat',
    question: 'Pitanje',
    submit: 'Podnesite',
    recent_activity: 'Nedavna aktivnost',
    ago: 'Pre',
    no_data_found: 'Nisu pronađeni podaci',
    start_end_live: 'Pokreni / Završi lajv',
    join_leave_date: 'Pridruži se / Napusti',
    watched_time: 'Vreme gledanja',
    complete: 'Kompletan',
    in_complete: 'Nekompletan',
    today: 'Danas',
    seven_days: '7 Dana',
    last_month: 'Prošlog meseca',
    one_year: '1 godina',
    all_time: 'Sve vreme',
    report: 'Izveštaj',
    from_date: 'Od datuma',
    to_date: 'Do datuma',
    all_workshop: 'Sve radionice',
    all_participants: 'Svi učesnici',
    live_assessment: 'Procena uživo',
    users: 'Korisnici',
    download: 'Preuzimanje',
    recent: 'Nedavno',
    WorkShop: 'Radionica',
    Activity: 'Aktivnost',
    created_date: 'Datum kreiranja',
    lessons: 'Lekcije',
    lesson: 'Lekcija',
    completed: 'Dovršeno',
    report_download: 'PREUZIMANJE',
    this_month: 'Ovog meseca',
    search_course: 'Pretraži kurs',
    // search_skill_journey: "Search Skill journey", // to translate
    search_maze: 'Pretraži lavirint', // to translate
    participants_graph: 'Grafikon učesnika',
    viewed: 'Pregledano',
    enrolled: 'Upisano',
    description: 'Opis',
    topic: 'Tema',
    analytic: 'Analitika',
    quiz_list: 'Spisak kvizova',
    select_one: 'Izaberite jedan',
    group_status: 'Status grupe',
    duration_min: 'Trajanje (min)',
    submit_poll: 'Prosledite anketu',
    download_events: 'Preuzmite događaje',
    search_event: 'Pretražite događaje',
    duration: 'Trajanje',
    total_participants: 'Ukupno učesnika',
    message: 'Poruka',
    avg_message: 'Pros. poruka',
    per_message: 'PROCENAT PORUKA / DOGAĐAJ',
    avg_score: 'Prosečan rezultat', // to translate
    maze: 'Lavirint', // to translate
    maze_report: 'Izveštaj o lavirintu', // to translate
    maze_view: 'Pregled lavirinta', // to translate
    title_maze: 'Lavirint', // to translate
    author: 'Autor', // to translate
    match: 'Podudaranje putanje', // to translate
    preview_mazeTitle: 'Naslov: ', // to translate
    other: 'Ostalo', // to translate
    total: 'UKUPNO', // to translate
    report_courses: 'KURSEVI', // to translate
    report_events: 'DOGAĐAJI', // to translate
    report_maze: 'LAVIRINT', // to translate
    report_personalize_learning: 'PERSONALIZOVANJE UČENJA', // to translate
    report_live_assessments: 'PROCENE UŽIVO', // to translate
    report_skill_journey: 'OBILAZAK VEŠTINA', // to translate
    skill_journey: 'Obilazak veština', // to translate
    skill_journeys: 'Obilazak veština', // to translate
    date: 'DATUM: ', // to translate
    search_people: 'Pretražite osobe', // to translate
    passed: 'POLOŽENO', // to translate
    failed: 'NIJE USPEŠNO', // to translate
    item: 'ARTIKAL', // to translate
    items: 'ARTIKLI', //to translate
    type: 'TIP', // to translate
    minimum_pass_score: 'MINIMALNI REZULTAT ZA PROLAZ', // to translate
    resources_count: 'BROJ RESURSA', // to translate
    back: 'NAZAD', // to translate
    resources: 'RESURSI', // to translate
    time_spent: 'UTROŠENO VREME (MIN)', // to translate
    detail: 'DETALJ', // to translate
    watched_time_mins: 'GLEDANO VREME (MIN)', // to translate
    personalize_learning: 'personalizovanje učenja', // to translate
    result: 'rezultat', // to translate
    assessment_title: 'Naslov' // to translate
  },

  signup: {
    success_step1:
      'Poslali smo verifikacioni kod na adresu koju ste uneli, molimo vas da kopirate kod u polje ispod da biste potvrdili vašu registraciju.',
    success_step2: 'Hvala. Uspešno ste registrovani.',
    privacy:
      'Slažem se sa Sharelook-ovim <1> dredbama i uslovima</1> i <3> pravilima privatnosti</3>'
  },

  stream: {
    emotion_impressive: 'Impresivno',
    emotion_unimpressive: 'Neimpresivno',
    message_not_started: 'Uskoro',
    message_running: 'Uživo',
    message_processing:
      'Trenutno obrađujemo snimak uživo za reprodukciju. Proverite kasnije da biste videli video zapis i nastavili da dodajete ocene i povratne informacije'
  },

  tabs: {
    audience: 'Publika',
    course: 'Pregled kursa',
    details: 'Detalji događaja uživo',
    description: 'Opis',
    host: 'Domaćin',
    lesson: 'Pregled lekcije',
    lessons: 'Lekcije',
    overview: 'Pregled',
    page: 'Izrada stranica',
    publish: 'Objavite',
    settings: 'Postavke objavljivanja',
    total_views: 'Ukupno pregleda',
    live_participates: 'Učesnici lajva',
    live_chats: 'Ćaskanje uživo',
    live_quiz: 'Ankete uživo',
    trainer_rating: 'Ocena trenera',
    trainer_times: 'Vreme trenera',
    courses_quizzes: 'Kvizovi kurseva',
    user_list: 'Spisak korisnika',
    discussion: 'Diskusija',
    notes: 'Moje beleške',
    attachments: 'Dodatni prilog' // to translate
  },

  topics: {
    SALES_TRAINING: 'Obuka o prodaji',
    NEGOTIATION_TRAINING: 'Obuka za pregovore',
    CROSS_CULTURAL_AWARENESS: 'Međukulturna svest',
    NETWORKING_SKILLS: 'Veštine umrežavanja',
    SOFTWARE_ARCHITECTURE: 'Izgradnja softvera',
    PROJECT_MANAGEMENT: 'Projektni Menadžment',
    DIGITAL_TRANSFORMATION: 'Digitalna transformacija',
    IT_CONSULTING: 'IT Konsalting',
    MANAGEMENT_CONSULTING: 'Menadžment Konsalting',
    HR_CONSULTING: 'HR Konsalting',
    INTERNET_OF_THINGS: 'Internet stvari (IoT)',
    CYBERSECURITY: 'Sajber bezbednost',
    PRIVACY_AND_GDRP: 'Privatnost i GDPR'
  },

  training: {
    title: 'Trening',
    title_assessment: 'Procene',
    subtitle: 'Kursevi i događaji uživo',
    enrolled_title: 'Upisani kursevi i događaji uživo',
    enrolled_subtitle: 'Kursevi i događaji uživo koje ste upisali',
    enrolled_message: 'Trenutno niste upisani ni na jedan kurs i događaj.',
    maze_channel: 'Moj Lavirint kanal', // to translate
    past_live_assessment: 'Prethodne procene uživo', // to translate
    no_live_assessment: 'Trenutno nema procena uživo', // to translate
    past_live_event_title: 'Prethodni događaji uživo',
    past_live_event_subTitle: 'Završeni događaji uživo',
    past_live_event: 'Trenutno nema prethodnih događaja uživo.',
    recomended_title: 'Preporučeni kursevi i događaji uživo',
    now_live_event_title: 'Sada uživo',
    now_live_event_subTitle: 'Događaji koji su uživo ili će biti vrlo brzo',
    now_live_event: 'Trenutno nema događaja uživo.',
    no_maze: 'Trenutno nema lavirinata.', // to translate
    webinar_event_title: 'Vebinar kanal',
    webinar_event_subTitle: 'Završeni Vebinari',
    webinar_event: 'Trenutno nema vebinara.',
    p2p_event_title: 'Trenerske sesije',
    p2p_event_subTitle: 'Završena trenerska sesija',
    p2p_event: 'Trenutno nema trenerskih sesija.',
    // new translate
    conference_event_title: 'Konferencije', // to translate
    conference_event_subTitle: 'Završene konferencije', // to translate
    conference_event: 'Trenutno nema konferencija.', // to translate
    skill_journey: 'Obilazak veština', // to translate
    no_skill: 'Trenutno nema obilaska veština.', // to translate

    now_live_assessment_title: 'Uživo sada',
    now_live_assessment_subTitle: 'Procena koja je uživo ili će biti vrlo brzo',
    now_live_assessment_message: 'Trenutno ne postoji procena uživo.',

    upcoming_assessment_title: 'Predstojeće procene uživo',
    upcoming_assessment_subtitle: 'Predstojeće procene uživo',
    upcoming_assessment_message:
      'Trenutno ne postoji predstojeća procena uživo',

    past_live_assessment_title: 'Prethodne procene uživo',
    past_live_assessment_subTitle: 'Završene procene uživo',
    past_live_assessment_message: 'Trenutno nema prethodnih procena uživo.',

    /**
     * <0/> get index 0 of data from Trans component
     * exp -->
     * <Trans i18nKey='training:recomended_subtitle' >
     *    <Navlink>{...something}</Navlink> --> is index 0 of Trans component
     *    <h1>{...something}</h1> --> is index 1 of Trans component
     * </Trans>
     */
    recomended_subtitle:
      'Kurseve i događaje uživo smo pripremili na osnovu vaših <0><0/></0>',
    /**
     * and we also can get data from index to replace in recommended_subtitle by like above string.
     * for exp -->
     * at the end of the recomended_subtitle above will get data from index of component to display
     * <0><0/></0> mean get data index 0 of Trans component above = <Navlink> and <0/> get data index 0 from <Navlink> = {...something}
     */
    search: 'Pretražite obuke',
    search_assessment: ' Pretražite procene',
    recomended_message: 'Trenutno nema preporučenih kurseva i događaja.',
    search_user: 'Pretpažite ime kompanije' // to translate
  },

  warnings: {
    delete: 'Da li ste sigurni?'
  },

  workshop: {
    title: 'Moja radionica',
    subtitle: 'Kreirajte kurs ili hostujte sopstveni događaj uživo',
    new_course: 'Kreirajte novi kurs',
    new_scorm_course: 'Otpremite novi SCORM kurs', // to translate
    upload_scorm_course: 'Otpremite SCORM kurs', // to translate
    new_event: 'Kreirajte novi događaj uživo',
    new_maze: 'Kreirajte novi lavirint', // to translate
    new_skill_journey: 'Kreirajte obilazak veština', // to translate
    new_assessment: 'Kreirajte nove procene uživo',
    courses_title: 'Kreirajte Kurseve i Događaje uživo',
    courses_subtitle: 'Edit & Publish your created course and plan live events',
    tags_course: 'Kurs',
    tags_scorm: 'SCORM', // to translate
    tags_live: 'Događaj uživo',
    tags_assessment: 'Procena uživo',
    tags_skillJourney: 'Obilazak veština' // to translate
  },

  help_center: {
    sidebar: {
      title: 'Kako možemo da vam pomognemo?',
      back_to: 'Kontrolna tabla'
    },
    menu: {
      help_center: 'Centar za pomoć',
      whats_new: 'Šta je novo',
      feedback: 'Povratne informacije',
      feedback_title: 'Pošaljite povratne informacije sharelook-u',
      terms_and_conditions: 'Odredbe & Uslovi',
      privacy_policy: 'Politika privatnosti',
      contact_us: 'Kontaktirajte nas'
    },
    get_started: {
      title: 'Zpočnite sa ShareLook-om',
      new_title: 'Korisnički vodič', // to translate
      description: {
        main: 'INTEGRISALI SMO VIDEO UŽIVO U JEDNOSTAVAN GRADITELJ KURSEVA',
        tagline:
          'Pomoću ShareLook-ovog patentiranog sistema emitovanja uživo možete da kreirate angažman, automatizujete učenje i maksimalno povećate deljenje znanja.'
      }
    },
    whats_new: {
      title: 'Zpočnite sa ShareLook-om',
      description: {
        main:
          'Da li ste znali da kreiranje storytelling stila učenja može da se stvori za kratko vreme i ne tako skupo? Trebalo bi da kombinujete ShareLook graditelja kurseva i talente. Možete nas pitati "KAKO”',
        tagline: 'slogan'
      }
    },
    create_workshop: 'Kako napraviti radionicu?',
    create_course: 'Kako napraviti kurs?',
    create_user: 'Kako napraviti korisnika?',
    create_group: 'Kako napraviti grupu?',
    create_webinar: 'Kako napraviti Vebinar?',
    create_live_event: 'Kako napraviti događaj uživo?',
    create_live_assessment: 'Kako napraviti procenu uživo?',
    create_live_on_mobile: 'Kreirajte uživo na mobilnom',
    personalize_profile: 'Personalizovanje profila',
    manage_group: 'Upravljanje grupom',
    report: 'Izveštaj',
    add_annotations: 'Kako dodati napomene/iskačuće prozore',
    add_audio: 'Kako dodati zvuk?',
    add_header_and_footer: 'Dodavanje zaglavlja i podnožja',
    add_image: 'Kako dodati sliku?',
    add_quiz_content: 'Kako dodati sadržaj kviza?',
    add_text_content: 'Kako dodati tekstualni sadržaj?',
    add_user: 'Kako dodati korisnika?',
    add_video: 'Kako dodati video?',
    clone_course: 'Kako klonirati kurs?',
    find_live_broadcast: 'Kako pronaći prenos uživo?',
    transcribe_and_translate_live_broadcast: 'Prevedi/transkribuj uživo prenos', // to translate
    transcribe_and_translate_your_live_broadcast:
      'Kako da transkribujete i prevedete prenos uživo', // to translate
    contact_us: {
      title: 'Kontaktirajte nas',
      subject_placeholder: 'Unesite temu*',
      content_placeholder: 'Unesite poruku*',
      subject_required: '*Tema je obavezna',
      content_required: '*Poruka je obavezna',
      submit: 'Pošalji',
      cancel: 'Otkaži',
      sent: 'Poslato'
    },
    feedback: {
      title: 'Pošalji povratne informacije sharelook-u',
      attach_title: 'Priložite datoteku',
      choose: 'Odaberite datoteku',
      detail: 'Datoteka će biti podeljena sa timom za podršku',
      content_placeholder: 'Unesite poruku*',
      content_required: '*Poruka je obavezna',
      submit: 'Pošalji',
      cancel: 'Otkaži',
      sent: 'Poslato'
    }
  },
  discussion: {
    join_discussion: 'Pridružite se diskusiji'
  },
  notes: {
    title: 'Moje beleške',
    add_note: 'Dodajte novu belešku'
  },
  // added_third
  groups: {
    search_group: 'Pretraži organizacionu grupu' // to translate
  },
  /* Information object is to be translated */
  v4: {
    title: 'Šta želiš da radiš danas?', // to translate
    build_course: 'Napravi moj kurs', // to translate
    live_broadcast: 'Prenos uživo', // to translate
    invite_users: 'Pozovi korisnike u moju organizaciju', // to translate
    build_voice_over: 'Napravi moj snimak glasa', // to translate
    view_reports: 'Prikaz izveštaja', // to translate
    upload_media: ' Otpremite moj medij ili posao i delite ga', // to translate
    main_menu: 'Glavni Meni', // to translate
    get_started: 'POČNITE' // to translate
  }
  /* To Translate  */
}
